import { applySnapshot, flow, getSnapshot, types } from 'mobx-state-tree'
import { newCardTypeDropdownData, newHeaderMap } from '../../components/NewCheckboxGrid/Fixtures'
import { extendAppSessionAPI } from '../../network/ExtendAppSession'
import { extendUserSessionAPI } from '../../network/ExtendUserSession'
import { addDevicePlanApi } from '../../network/addDevicePlanApi'
import { addDeviceVariantApi } from '../../network/addDeviceVariantApi'
import { addVariantMasterApi } from '../../network/addVariantMasterApi'
import { createVpa } from '../../network/createVpa'
import { deleteDevicePlanApi } from '../../network/deleteDevicePlanApi'
import { deleteDeviceVariantApi } from '../../network/deleteDeviceVariantApi'
import { getFormattedDate } from '../../network/eosCreateWorkItem'
import { generateQr } from '../../network/generateQr'
import { getAllVpas } from '../../network/getAllVpas'
import { getAssignedDevicesToMidApi } from '../../network/getAssignedDevicesToMidApi'
import { getDeviceVariantListApi } from '../../network/getDeviceVariantListApi'
import { getMerchantQrByVpa } from '../../network/getMerchantQrByVpa'
import { getMerchantWithMid } from '../../network/getMerhcantWithMid'
import { getVariantPlanListApi } from '../../network/getVariantPlanListApi'
import { insertMerchant } from '../../network/insertMerchant'
import { saveEmiConfig } from '../../network/saveEmiConfig'
import { saveOnboardingData } from '../../network/saveOnboardingData'
import { uploadBulkEntitiesFileReq } from '../../network/uploadBulkEntitiesFileReq'
import { EmType } from '../../screens/EntityManagement'
import { MessageTypes, getErrorMessage, isEmpty } from '../../utils'
import { CardSchema, ENABLE_DUMMY_OWN_CHANNEL_ID } from '../../utils/constants'
import { RootStore } from '../store'
import { getIsCheckedFromCardSearchConfig } from '../store/Root'
import { PAYMENT_MODE_SUBTYPES } from './../../../../pg/src/utils/constants'
import { MerchantData } from './../../network/insertMerchant'
import { Merchant } from './Merchant'

const getVpaQrUrl = (terminalDetails: any) => {
  if (terminalDetails) {
    if (Array.isArray(terminalDetails?.vpaLinkings)) {
      if (
        terminalDetails?.vpaLinkings &&
        terminalDetails?.vpaLinkings?.length > 0 &&
        terminalDetails?.vpaLinkings?.[0]?.vpa?.length > 0 &&
        terminalDetails?.vpaLinkings?.[0]?.qrUrl?.length > 0
      ) {
        return `${terminalDetails?.vpaLinkings?.[0]?.vpa},${terminalDetails?.vpaLinkings?.[0]?.qrUrl}`
      } else {
        return ''
      }
    } else {
      if (
        terminalDetails?.vpaLinkings &&
        terminalDetails?.vpaLinkings?.vpa?.length > 0 &&
        terminalDetails?.vpaLinkings?.qrUrl?.length > 0
      ) {
        return `${terminalDetails?.vpaLinkings?.vpa},${terminalDetails?.vpaLinkings?.qrUrl}`
      } else {
        return ''
      }
    }
  } else {
    return ''
  }
}
const getEntityContactAddress = (contact: any, isMasMidFlow: boolean) => {
  let entityContactAddress = {
    addressLine1: contact?.address1 ?? contact?.addressLine1,
    addressLine2: contact?.address2 ?? contact?.addressLine2,
    pincode: contact?.pincode,
    city: contact?.city,
    state: contact?.state,
    country: contact?.country,
  }
  let emsContactAddress = null
  if (!isMasMidFlow) {
    if (
      contact?.addressLine1?.length > 0 ||
      contact?.addressLine2?.length > 0 ||
      contact?.pincode?.length > 0 ||
      contact?.city?.length > 0 ||
      contact?.state?.length > 0 ||
      contact?.country?.length > 0
    ) {
      emsContactAddress = {
        ...(contact?.addressLine1 !== 'NA' && { addressLine1: contact?.addressLine1 }),
        ...(contact?.addressLine2 !== 'NA' && { addressLine2: contact?.addressLine2 }),
        ...(contact?.pincode !== 'NA' && { pincode: contact?.pincode }),
        ...(contact?.state !== 'NA' && { state: contact?.state }),
        ...(contact?.country !== 'NA' && { country: contact?.country }),
        ...(contact?.city !== 'NA' && { city: contact?.city }),
      }
    }
  }
  return isMasMidFlow ? entityContactAddress : emsContactAddress
}
const checkIfConfigPresentInUpdatedEntityConfigs = (updatedEntityConfigs: any[], configType: string, key: string) => {
  let isPresent = false
  for (let i = 0; i < updatedEntityConfigs?.length; i++) {
    if (updatedEntityConfigs?.[i]?.configType === configType) {
      for (let j = 0; j < updatedEntityConfigs?.[i]?.configValues?.length; j++) {
        if (updatedEntityConfigs?.[i]?.configValues?.[j]?.key === key) {
          isPresent = true
          break
        }
      }
    }
  }
  return isPresent
}

const isDataChanged = (existingData: string, updatedData: string) => {
  if (existingData !== null && existingData !== undefined) {
    return existingData !== updatedData
  } else {
    return true
  }
}

let initialState = {}

const getBusinessProfileId = (entId: string, searchEntityList: any[]) => {
  return searchEntityList.filter((entity) => entity.identificationNumber === entId)?.[0]?.entity?.businessProfile?.id
}

const getGstId = (entId: string, searchEntityList: any[]) => {
  return searchEntityList.filter((entity) => entity.identificationNumber === entId)?.[0]?.entity?.gstDetails?.id
}

const getFeePackageDetailsIdGstId = (entId: string, searchEntityList: any[]) => {
  return searchEntityList.filter((entity) => entity.identificationNumber === entId)?.[0]?.entity?.feePackageDetails?.id
}
const getAddressDetailsId = (entId: string, searchEntityList: any[]) => {
  return searchEntityList.filter((entity) => entity.identificationNumber === entId)?.[0]?.entity?.addressDetails?.[0]
    ?.id
}

const getParentEntityIdentificationId = (id: string) => {
  return { parentEntityIdentificationNumber: id }
}

const getSubGroupIdentificationNumber = (id: string) => {
  return { subGroupIdentificationNumber: id }
}

const getMappedKey = (key: string) => {
  const keyValue: any = {
    'Terms & Conditions': 'TERMS_CONDITIONS',
    'Privacy Policy': 'PRIVACY_POLICY',
    'Refund Cancellation Policy': 'REFUND_CANCELLATION_POLICY',
    'About Us': 'ABOUT_US',
    'Contact Us': 'CONTACT_US',
    'Create Mandate': '310',
    PreProcess: '306',
    EMI: '114',
    'Payment Intent': '300',
    Refund: '211',
    'URL for Purchase': '110',
    'General Callback': 'S2S_URL',
  }
  return keyValue[key]
}
export const getUrlConfigs = (urls: any[], type: string) => {
  const configs: any[] = []
  if (urls.length > 0) {
    urls.map((url) => {
      const data = {
        configType: type,
        configValues: [
          {
            status: 'ACTIVE',
            key: getMappedKey(url.type),
            value: url.url,
          },
        ],
      }
      configs.push(data)
    })
  }
  return configs
}

const getPayAcceptanceKey = (name: string) => {
  const obj: any = {
    UPI: '566',
    NetBanking: '581',
    Cards: '582',
    Wallets: '579',
    'Pay Later': '601',
  }
  return obj[name]
}

const getExactConfigKey = (name: string) => {
  const obj: any = {
    isDuplicateTxnAllowed: 'ALLOW_DUPLICATES',
    isRandomTxnAllowed: 'RANDOM_QR',
    qrTxnPattern: 'INVOICE_REGEX_PATTERN',
    SUPPORTED_PROCESSING_ENTITY: 'SUPPORTED_PROCESSING_ENTITY',
  }
  return obj[name]
}

const getRefIdValue = (key: string, configType: string, configurations: any[]) => {
  let refId = ''
  let value = ''
  if (configurations && configurations?.length > 0) {
    configurations.map((config) => {
      if (config.key === key && config.configType === configType) {
        refId = config.configValuesReferenceId
        value = config.value
      }
    })
  }
  return { refId, value }
}

export const getUpiRefId = (key: string, value: string, configs: any[]) => {
  let refId = ''
  configs.map((conf) => {
    if (conf.key === key) {
      refId = conf.configValuesReferenceId
    }
  })
  return refId
}
export const getRefIdForPaymentInstruments = (key: string, value: string, configs: any[]) => {
  let refId = ''
  configs.map((conf) => {
    if (conf.key === key && conf.value === value) {
      refId = conf.configValuesReferenceId
    }
  })
  return refId
}

const checkIsConfigPresent = (key: string, value: boolean, configList: any[]) => {
  return configList && configList.length > 0 && configList.filter((conf) => conf.key === key).length > 0
}

const checkIsPartnerConfigPresent = (key: string, value: boolean, configList: any[]) => {
  return (
    configList &&
    configList.length > 0 &&
    configList.filter((conf) => conf.key === key && conf.value === value).length > 0
  )
}

const checkIfFiuDataPresent = (data: any, dataList: any[]) => {
  dataList && dataList.length > 0 && dataList.filter((mData) => mData.dob === data?.dob).length > 0
}

const PaymentConfigData = [
  {
    id: 1,
    name: 'UPI',
    isChecked: false,
    isSelected: false,
    icon: '',
  },
  {
    id: 2,
    name: 'NetBanking',
    isChecked: false,
    isSelected: false,
    icon: 'BANK',
  },
  {
    id: 3,
    name: 'Cards',
    isChecked: false,
    isSelected: false,
    icon: 'CARD_CVV',
  },
  {
    id: 4,
    name: 'Wallets',
    isChecked: false,
    isSelected: false,
    icon: 'WALLET',
  },
  // {
  //   id: 5,
  //   name: 'EMI',
  //   isChecked: false,
  //   isSelected: false,
  //   icon: 'EMI',
  // },
  {
    id: 6,
    name: 'Pay Later',
    isChecked: false,
    isSelected: false,
    icon: 'PAYLATER',
  },
  {
    id: 7,
    name: 'Corporate NetBanking',
    isChecked: false,
    isSelected: false,
    icon: 'BANK',
  },
]

const CardConfigInitArr = [
  {
    name: 'VISA',
    Credit: false,
    Debit: false,
    FoodCard: false,
    H: false,
    Prepaid: false,
    R: false,
    isChecked: false,
  },
  {
    name: 'Discover',
    Credit: false,
    Debit: false,
    FoodCard: false,
    H: false,
    Prepaid: false,
    R: false,
    isChecked: false,
  },
  {
    name: 'DINA',
    Credit: false,
    Debit: false,
    FoodCard: false,
    H: false,
    Prepaid: false,
    R: false,
    isChecked: false,
  },
  {
    name: 'Cup',
    Credit: false,
    Debit: false,
    FoodCard: false,
    H: false,
    Prepaid: false,
    R: false,
    isChecked: false,
  },
  {
    name: 'Amex',
    Credit: false,
    Debit: false,
    FoodCard: false,
    H: false,
    Prepaid: false,
    R: false,
    isChecked: false,
  },
  {
    name: 'Diners',
    Credit: false,
    Debit: false,
    FoodCard: false,
    H: false,
    Prepaid: false,
    R: false,
    isChecked: false,
  },
  {
    name: 'Master',
    Credit: false,
    Debit: false,
    FoodCard: false,
    H: false,
    Prepaid: false,
    R: false,
    isChecked: false,
  },
  {
    name: 'Rupay',
    Credit: false,
    Debit: false,
    FoodCard: false,
    H: false,
    Prepaid: false,
    R: false,
    isChecked: false,
  },
  {
    name: 'RSPL',
    Credit: false,
    Debit: false,
    FoodCard: false,
    H: false,
    Prepaid: false,
    R: false,
    isChecked: false,
  },
  {
    name: 'FDC',
    Credit: false,
    Debit: false,
    FoodCard: false,
    H: false,
    Prepaid: false,
    R: false,
    isChecked: false,
  },
  {
    name: 'EuroPay',
    Credit: false,
    Debit: false,
    FoodCard: false,
    H: false,
    Prepaid: false,
    R: false,
    isChecked: false,
  },
  {
    name: 'JCB',
    Credit: false,
    Debit: false,
    FoodCard: false,
    H: false,
    Prepaid: false,
    R: false,
    isChecked: false,
  },
]

const ContactProfileData = {
  id: 0,
  mobileNumber: '',
  firstName: '',
  lastName: '',
  dob: '',
  gender: '',
  emailId: '',
  phone1: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  pincode: '',
  role: '',
}

const CardSubTypes = [
  { subType: 'Domestic', isSelected: false },
  { subType: 'International', isSelected: false },
  { subType: 'Platinum', isSelected: false },
]

const Vpa = types.model('Vpa', {
  id: types.maybeNull(types.union(types.number, types.string)),
  vpa: types.maybeNull(types.string),
  mindgateId: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  handle: types.maybeNull(types.string),
  qrUrl: types.maybeNull(types.string),
})

const PaymentConfig = types.model('PaymentConfig', {
  id: types.optional(types.number, 0),
  name: types.optional(types.string, ''),
  isChecked: types.optional(types.boolean, false),
  isSelected: types.optional(types.boolean, false),
  icon: types.optional(types.string, ''),
  iconSelected: types.optional(types.string, ''),
  iconDisabled: types.optional(types.string, ''),
})

const CardConfig = types.model('CardConfig', {
  Credit: types.optional(types.boolean, false),
  Debit: types.optional(types.boolean, false),
  FoodCard: types.optional(types.boolean, false),
  H: types.optional(types.boolean, false),
  Prepaid: types.optional(types.boolean, false),
  R: types.optional(types.boolean, false),
  name: types.optional(types.string, ''),
  isChecked: types.optional(types.boolean, false),
})

const GstNumber = types.model('GstNumber', {
  id: types.optional(types.string, ''),
  gstNumber: types.optional(types.string, ''),
  isDefault: types.optional(types.boolean, false),
})

const GstConfig = types.model('GstConfig', {
  gstConsent: types.optional(types.boolean, false),
  gstNumbers: types.optional(types.array(GstNumber), [
    { id: '1.', gstNumber: '1231232131312321', isDefault: true },
    { id: '2.', gstNumber: '1231232131312321', isDefault: false },
  ]),
})

const UpiConfig = types.model('UpiConfig', {
  isDuplicateTxnAllowed: types.optional(types.boolean, false),
  isRandomTxnAllowed: types.optional(types.boolean, false),
  issueRefundAllowed: types.optional(types.boolean, false),
  isConvenienceFeeAllowed: types.optional(types.boolean, false),
  isTipAllowed: types.optional(types.boolean, false),
  qrTxnPattern: types.optional(types.string, ''),
  refundPercentage: types.optional(types.string, ''),
  convFeePercentage: types.optional(types.string, ''),
  tipPercentage: types.optional(types.string, ''),
  transactionLimit: types.optional(types.string, ''),
  exitLimit: types.optional(types.string, ''),
  transactionCount: types.optional(types.string, ''),
  applyRefsConvTipsToAllPayments: types.optional(types.boolean, false),
  applyLimitsAllPayments: types.optional(types.boolean, false),
  gstConfig: types.optional(GstConfig, {}),
})

const BankOrPartnerConfig = types.model('BankOrPartnerConfig', {
  s2sUrl: types.optional(types.string, ''),
  partnerMeMid: types.optional(types.string, ''),
})

const EntityContactAddress = types.model('EntityContactAddress', {
  addressLine1: types.maybeNull(types.string),
  addressLine2: types.maybeNull(types.string),
  pincode: types.maybeNull(types.string),
  city: types.maybeNull(types.string),
  state: types.maybeNull(types.string),
  countryCode: types.maybeNull(types.string),
  groupContactAddressKey: types.maybeNull(types.string),
  addressType: types.maybeNull(types.string),
})

const ContactNotification = types.model('ContactNotification', {
  sms: types.maybeNull(types.boolean),
  email: types.maybeNull(types.boolean),
  groupContactNotificationKey: types.maybeNull(types.string),
})

const ContactProfile = types.model('ContactProfile', {
  id: types.maybeNull(types.union(types.number, types.string)),
  salutation: types.maybeNull(types.string),
  mobileNumber: types.maybeNull(types.string),
  firstName: types.maybeNull(types.string),
  middleName: types.maybeNull(types.string),
  lastName: types.maybeNull(types.string),
  professionalTitle: types.maybeNull(types.string),
  dateOfBirth: types.maybeNull(types.string),
  gender: types.maybeNull(types.string),
  emailId: types.maybeNull(types.string),
  websiteEmailId: types.maybeNull(types.string),
  websiteUrl: types.maybeNull(types.string),
  phoneExt: types.maybeNull(types.string),
  phone1: types.maybeNull(types.string),
  phone2: types.maybeNull(types.string),
  fax: types.maybeNull(types.string),
  allowNotification: types.maybeNull(types.string),
  role: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  country: types.maybeNull(types.string),
  entityContactAddress: types.maybeNull(EntityContactAddress),
  groupContactAddress: types.maybeNull(EntityContactAddress),
  groupContactNotification: types.maybeNull(ContactNotification),
  addressLine1: types.maybeNull(types.string),
  addressLine2: types.maybeNull(types.string),
  addressLine3: types.maybeNull(types.string),
  address1: types.maybeNull(types.string),
  address2: types.maybeNull(types.string),
  city: types.maybeNull(types.string),
  district: types.maybeNull(types.string),
  state: types.maybeNull(types.string),
  pincode: types.maybeNull(types.string),
  countryCode: types.maybeNull(types.string),
  latitude: types.maybeNull(types.string),
  longitude: types.maybeNull(types.string),
  landlineNumber: types.maybeNull(types.string),
  groupContactReferenceId: types.maybeNull(types.string),
  type: types.maybeNull(types.string),
  dob: types.maybeNull(types.string),
})

const ProgramDetail = types.model('ProgramDetail', {
  id: types.maybeNull(types.union(types.number, types.string)),
  programId: types.maybeNull(types.string),
  category: types.maybeNull(types.string),
  referenceId: types.maybeNull(types.string),
  pname: types.maybeNull(types.string),
  refValidation: types.maybeNull(types.boolean),
})

const Address = types.model('Address', {
  id: types.maybeNull(types.union(types.number, types.string)),
  addressType: types.maybeNull(types.string),
  pincode: types.maybeNull(types.string),
  state: types.maybeNull(types.string),
  countryCode: types.maybeNull(types.string),
  latitude: types.maybeNull(types.string),
  longitude: types.maybeNull(types.string),
  addressRole: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  addressLine1: types.maybeNull(types.string),
  addressLine2: types.maybeNull(types.string),
  addressLine3: types.maybeNull(types.string),
  addressLine4: types.maybeNull(types.string),
  city: types.maybeNull(types.string),
  groupAddressReferenceId: types.maybeNull(types.string),
  phone1: types.maybeNull(types.string),
  phone2: types.maybeNull(types.string),
  fax: types.maybeNull(types.string),
  emailAddr: types.maybeNull(types.string),
  stateAbbrev: types.maybeNull(types.string),
  geoCode: types.maybeNull(types.string),
  country: types.maybeNull(types.string),
})

const Group = types.model('Group', {
  groupId: types.maybeNull(types.string),
  groupName: types.maybeNull(types.string),
  legalName: types.maybeNull(types.string),
  brandName: types.maybeNull(types.string),
  type: types.maybeNull(types.string),
  createdAt: types.maybeNull(types.string),
  identificationNumber: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  groupAddress: types.maybeNull(types.array(Address)),
  groupContacts: types.maybeNull(types.array(ContactProfile)),
})

const SubGroup = types.model('SubGroup', {
  brandName: types.maybeNull(types.string),
  type: types.maybeNull(types.string),
  legalName: types.maybeNull(types.string),
  createdBy: types.maybeNull(types.string),
  createdAt: types.maybeNull(types.string),
  updatedBy: types.maybeNull(types.string),
  updatedAt: types.maybeNull(types.string),
  identificationNumber: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  group: types.maybeNull(Group),
})

const Gst = types.model('Gst', {
  id: types.maybeNull(types.union(types.number, types.string)),
  gstin: types.maybeNull(types.string),
  gstCategory: types.maybeNull(types.string),
  dealerCategory: types.maybeNull(types.string),
  typeOfBusiness: types.maybeNull(types.string),
  gstNumber: types.maybeNull(types.string),
  dateOfExpiry: types.maybeNull(types.string),
  jioGstAcceptanceTs: types.maybeNull(types.string),
  merchantCategory: types.maybeNull(types.string),
  jioGST: types.maybeNull(types.string),
})

const SettlementAccount = types.model('Settlement', {
  id: types.maybeNull(types.union(types.number, types.string)),
  accountNumber: types.maybeNull(types.string),
  ifsCode: types.maybeNull(types.string),
  bankName: types.maybeNull(types.string),
  branch: types.maybeNull(types.string),
  branchName: types.maybeNull(types.string),
  bankCity: types.maybeNull(types.string),
  beneficiaryName: types.maybeNull(types.string),
  settlementFrequency: types.maybeNull(types.number),
  settlementPlanId: types.maybeNull(types.string),
  settlementStatus: types.maybeNull(types.string),
  allowSettlement: types.maybeNull(types.boolean),
  settlPlanId: types.maybeNull(types.number),
  acctType: types.maybeNull(types.string),
  acctPostingType: types.maybeNull(types.string),
  entityAcctCurr: types.maybeNull(types.string),
  entityAcctId: types.maybeNull(types.number),
  setupCompleteInd: types.maybeNull(types.string),
  effectiveDate: types.maybeNull(types.string),
  entityAcctDesc: types.maybeNull(types.string),
  settlAcctNbr: types.maybeNull(types.string),
  dailyTransactionValue: types.maybeNull(types.string),
})

const FeePackage = types.model('FeePackage', {
  id: types.maybeNull(types.union(types.number, types.string)),
  startDate: types.maybeNull(types.string),
  endDate: types.maybeNull(types.string),
  feePkgId: types.maybeNull(types.number),
  inheritParentFeePackage: types.maybeNull(types.boolean),
  feePackageName: types.maybeNull(types.string),
})

const Kyc = types.model('Kyc', {
  id: types.maybeNull(types.union(types.number, types.string)),
  documentCategory: types.maybeNull(types.string),
  documentName: types.maybeNull(types.string),
  documentNumber: types.maybeNull(types.string),
  dateOfExpiry: types.maybeNull(types.string),
  kycStatus: types.maybeNull(types.string),
  docSubmitted: types.maybeNull(types.string),
  expiryDate: types.maybeNull(types.string),
  kycCreationDate: types.maybeNull(types.string),
  kycApprovalDate: types.maybeNull(types.string),
  kycRemarks: types.maybeNull(types.string),
  createdFrom: types.maybeNull(types.string),
  createdBy: types.maybeNull(types.string),
  createdAt: types.maybeNull(types.string),
  updatedFrom: types.maybeNull(types.string),
  updatedBy: types.maybeNull(types.string),
  updatedAt: types.maybeNull(types.string),
  jdmsId: types.maybeNull(types.string),
  chequeLeafFlag: types.maybeNull(types.string),
})

const StoreCodeDetails = types.model('StoreCodeDetails', {
  storeCode: types.maybeNull(types.string),
  format: types.maybeNull(types.string),
})

const BusinessProfile = types.model('BusinessProfile', {
  id: types.maybeNull(types.union(types.number, types.string)),
  ownershipType: types.maybeNull(types.string),
  businessChannel: types.maybeNull(types.string),
  setUpLevel: types.maybeNull(types.string),
  premiseType: types.maybeNull(types.string),
  businessPan: types.maybeNull(types.string),
  webAddress: types.maybeNull(types.string),
  storeType: types.maybeNull(types.string),
  pharmacistName: types.maybeNull(types.string), //Mandatory only for MCC related to pharmacy
  pharmacyCouncilNumber: types.maybeNull(types.string), //Mandatory only for MCC related to pharmacy
  yearsInBusiness: types.maybeNull(types.string),
  annualRevenueSegment: types.maybeNull(types.string),
  businessLine: types.maybeNull(types.string),
  mccCode: types.maybeNull(types.string),
  businessCategory: types.maybeNull(types.string),
  dailyTransactionVolume: types.maybeNull(types.string),
  dailyTransactionValue: types.maybeNull(types.string),
  marketPlace: types.maybeNull(types.string),
  merchIrctcFlag: types.maybeNull(types.string),
  agentId: types.maybeNull(types.string),
  cin: types.maybeNull(types.string),
  dateOfIncorporation: types.maybeNull(types.string),
})

const TerminalConfiguration = types.model('TerminalConfiguration', {
  key: types.maybeNull(types.string),
  value: types.maybeNull(types.union(types.boolean, types.string)),
})

const Device = types.model('Device', {
  // id: types.optional(types.string, ''),
  // deviceType: types.optional(types.string, ''),
  // imei: types.optional(types.number, 0),
  // dongleKeyAlias: types.optional(types.string, ''),
  deviceStatus: types.maybeNull(types.string),
  deviceSerialNo: types.maybeNull(types.string),
  deviceLinkingStatus: types.maybeNull(types.string),
  manufacturerName: types.maybeNull(types.string),
  entityIdLinkDate: types.maybeNull(types.string),
  deviceType: types.maybeNull(types.string),
  // institutionId: types.optional(types.string, ''),
  // manufacturerName: types.optional(types.string, ''),
  // entityIdentificationNumber: types.optional(types.string, ''),
  // entityLinkDate: types.optional(types.string, ''),
  // entityUnlinkDate: types.optional(types.string, ''),
  // terminalLinkDate: types.optional(types.string, ''),
  // terminalUnlinkDate: types.optional(types.string, ''),
  // terminalIdentificationNumber: types.optional(types.string, ''),
})

const TerminalDetail = types.model('TerminalDetail', {
  terminalId: types.maybeNull(types.string),
  mid: types.maybeNull(types.string),
  deviceSerialNo: types.maybeNull(types.string),
  terminalType: types.maybeNull(types.string),
  mobileNumber: types.maybeNull(types.string),
  nickName: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  terminalConfigurationDetails: types.maybeNull(types.array(TerminalConfiguration)),
  vpaLinkings: types.maybeNull(types.union(types.array(Vpa), Vpa)),
  vpaLinkingDetails: types.maybeNull(Vpa),
  device: types.maybeNull(Device),
  firstName: types.maybeNull(types.string),
  posMsgBrand: types.maybeNull(types.number),
  dailyTransactionValue: types.maybeNull(types.string),
  dailyTransactionVolume: types.maybeNull(types.string),
  closeDate: types.maybeNull(types.string),
  primary: types.maybeNull(types.boolean),
})

const AuthorisedSignatoryDetails = types.model('AuthorisedSignatoryDetails', {
  authSigDOB: types.maybeNull(types.string),
  authSigFirstname: types.maybeNull(types.string),
  authSigMidname: types.maybeNull(types.string),
  authSigLastname: types.maybeNull(types.string),
  authSigGender: types.maybeNull(types.string),
  authSignDOC: types.maybeNull(types.string),
  authSigSalutation: types.maybeNull(types.string),
  locLangMerchdesc: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  authorisedSignatoryReferenceId: types.maybeNull(types.string),
  reasonCode: types.maybeNull(types.string),
  action: types.maybeNull(types.string),
})

const BeneficialOwnerEntity = types.model('BeneficialOwnerEntity', {
  id: types.maybeNull(types.string),
  firstName: types.maybeNull(types.string),
  middleName: types.maybeNull(types.string),
  lastName: types.maybeNull(types.string),
  dob: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  beneficialOwnerReferenceId: types.maybeNull(types.string),
  action: types.maybeNull(types.string),
})

const DirectorEntities = types.model('DirectorEntities', {
  din: types.maybeNull(types.string),
  firstName: types.maybeNull(types.string),
  middleName: types.maybeNull(types.string),
  lastName: types.maybeNull(types.string),
  dob: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  directorReferenceId: types.maybeNull(types.string),
  surrenderedDin: types.maybeNull(types.string),
  beginAt: types.maybeNull(types.string),
  endAt: types.maybeNull(types.string),
  action: types.maybeNull(types.string),
})

const Checker = types.model('CheckerList', {
  applicationId: types.identifier,
  legalName: types.maybeNull(types.string),
  brandName: types.maybeNull(types.string),
  businessName: types.maybeNull(types.string),
  creationDate: types.maybeNull(types.string),
  mobileNumber: types.maybeNull(types.string),
  requestType: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  isSelected: types.maybeNull(types.boolean),
  assignee: types.maybeNull(types.string),
  applicationType: types.maybeNull(types.string),
  groupAddress: types.maybeNull(types.array(Address)),
  groupContacts: types.maybeNull(types.array(ContactProfile)),
  type: types.maybeNull(types.string),
  comments: types.maybeNull(types.string),
  contactDetails: types.maybeNull(types.array(ContactProfile)),
  businessProfile: types.maybeNull(BusinessProfile),
  addressDetails: types.maybeNull(types.array(Address)),
  identificationNumber: types.maybeNull(types.string),
  gstDetails: types.maybeNull(Gst),
  settlementDetails: types.maybeNull(SettlementAccount),
  feePackageDetails: types.maybeNull(FeePackage),
  programCategoryDetails: types.maybeNull(types.array(ProgramDetail)),
  deviceDetails: types.maybeNull(types.array(Device)),
  source: types.maybeNull(types.string),
  parentEntityIdentificationNumber: types.maybeNull(types.string),
  subGroupIdentificationNumber: types.maybeNull(types.string),
  applicationStatus: types.maybeNull(types.string),
  errorReason: types.maybeNull(types.string),
  errorTask: types.maybeNull(types.string),
  inProgressTask: types.maybeNull(types.string),
  completedTaskList: types.optional(types.array(types.string), []),
  terminalDetails: types.maybeNull(types.array(TerminalDetail)),
  jfsUserid: types.maybeNull(types.string),
  uploadId: types.maybeNull(types.string),
  auditType: types.maybeNull(types.string),
  createdAt: types.maybeNull(types.string),
  createdBy: types.maybeNull(types.string),
  authorisedSignatory: types.maybeNull(types.array(AuthorisedSignatoryDetails)),
  beneficialOwnerDetails: types.maybeNull(types.array(BeneficialOwnerEntity)),
  directorDetails: types.maybeNull(types.array(DirectorEntities)),
  makerComments: types.maybeNull(types.string),
  action: types.maybeNull(types.string),
  taskInstanceId: types.maybeNull(types.string),
  processInstanceId: types.maybeNull(types.string),
})

const Entity = types.model('Entity', {
  id: types.maybeNull(types.union(types.number, types.string)),
  parentEntityIdentificationNumber: types.maybeNull(types.string),
  subGroupIdentificationNumber: types.maybeNull(types.string),
  identificationNumber: types.maybeNull(types.string),
  entityLevel: types.maybeNull(types.number),
  type: types.maybeNull(types.string),
  legalName: types.maybeNull(types.string),
  businessName: types.maybeNull(types.string),
  merchantOtpDate: types.maybeNull(types.string),
  deviceOtpDate: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  contactDetails: types.maybeNull(types.array(ContactProfile)),
  addressDetails: types.maybeNull(types.array(Address)),
  gstDetails: types.maybeNull(Gst),
  settlementDetails: types.maybeNull(SettlementAccount),
  feePackageDetails: types.maybeNull(FeePackage),
  vpaDetails: types.maybeNull(types.array(Vpa)),
  programCategoryDetails: types.maybeNull(types.array(ProgramDetail)),
  kycDetailDetails: types.maybeNull(types.array(Kyc)),
  terminalDetails: types.maybeNull(types.array(TerminalDetail)),
  businessProfile: types.maybeNull(BusinessProfile),
  source: types.maybeNull(types.string),
  ownerType: types.maybeNull(types.string),
  name: types.maybeNull(types.string),
  oldStatus: types.maybeNull(types.string),
  defPostingEntity: types.maybeNull(types.string),
  activatedAt: types.maybeNull(types.string),
  terminatedAt: types.maybeNull(types.string),
  authorisedSignatoryDetails: types.maybeNull(AuthorisedSignatoryDetails),
  masParentId: types.maybeNull(types.string),
  legalOwnerName: types.maybeNull(types.string),
  merchantLevel: types.maybeNull(types.string),
  authorisedSignatories: types.maybeNull(types.array(AuthorisedSignatoryDetails)),
  storeCodeDetails: types.maybeNull(StoreCodeDetails),
})

const BusinessDetail = types.model('BusinessDetail', {
  //Business Details
  emType: types.optional(types.string, ''),
  legalEntityName: types.optional(types.string, ''),
  businessBrandName: types.optional(types.string, ''),
  ownershipType: types.optional(types.string, ''),
  businessChannel: types.optional(types.string, ''),
  setupLevel: types.optional(types.string, ''),
  premiseType: types.maybeNull(types.string),
  businessPAN: types.maybeNull(types.string),
  webAddress: types.maybeNull(types.string),
  storeType: types.maybeNull(types.string),
  yearsOfBusiness: types.optional(types.string, ''),
  dailyTransactionValue: types.optional(types.string, ''),
  dailyTransactionVolume: types.optional(types.string, ''),
  merchantOtpDate: types.maybeNull(types.string),
  deviceOtpDate: types.maybeNull(types.string),
  yearsInBusiness: types.maybeNull(types.string),
  businessLine: types.maybeNull(types.string),
  businessCategory: types.maybeNull(types.string),
  // Business Category
  mccCode: types.optional(types.string, ''),
  mccBusinessCategory: types.optional(types.string, ''),
  mCCDescriptionBusinessLine: types.optional(types.string, ''),
  isPharmacyCase: types.optional(types.boolean, false),
  pharmacistName: types.optional(types.string, ''),
  pharmacyCouncilNumber: types.optional(types.string, ''),
  // Business Address
  primaryAddress1: types.optional(types.string, ''),
  primaryAddress2: types.optional(types.string, ''),
  pincode: types.optional(types.string, ''),
  city: types.optional(types.string, ''),
  stateUt: types.optional(types.string, ''),
  businessLatitude: types.optional(types.string, ''),
  businessLongitude: types.optional(types.string, ''),
  // GST Details
  gstCategory: types.maybeNull(types.string),
  gstDealerCategory: types.maybeNull(types.string),
  typeOfBusiness: types.maybeNull(types.string),
  gstNumber: types.maybeNull(types.string),
  dateOfExpiry: types.maybeNull(types.string),
  jioGstAcceptanceTs: types.maybeNull(types.string),

  //FEE Package
  inheritParentFeePackage: types.maybeNull(types.string),
  mdrPackageId: types.maybeNull(types.string),
  mdrPackageDetails: types.maybeNull(types.string),

  //Settlement details
  settlementAccount: types.maybeNull(types.string),
  ifsc: types.maybeNull(types.string),
  bankName: types.maybeNull(types.string),
  branch: types.maybeNull(types.string),
  bankCity: types.maybeNull(types.string),
  beneficiaryName: types.maybeNull(types.string),
  settlementFrequency: types.maybeNull(types.string),
  settlementPlanID: types.maybeNull(types.string),
  settlementStatus: types.maybeNull(types.string),
  allowSettlement: types.maybeNull(types.boolean),
})

const Parent = types.model('Parent', {
  entityLevel: types.maybeNull(types.number),
  identificationNumber: types.maybeNull(types.string),
  businessName: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
})

const Child = types.model('Child', {
  entityLevel: types.maybeNull(types.number),
  identificationNumber: types.maybeNull(types.string),
  businessName: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
})

const Configurations = types.model('Configurations', {
  configType: types.maybeNull(types.string),
  key: types.maybeNull(types.string),
  value: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  configValuesReferenceId: types.maybeNull(types.string),
})

const Config = types.model('Config', {
  key: types.maybeNull(types.string),
  value: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  configValuesReferenceId: types.maybeNull(types.string),
})

const EntityConfig = types.model('EntityConfig', {
  configType: types.maybeNull(types.string),
  configValues: types.maybeNull(types.array(Config)),
})

const RiskConfigurations = types.model('RiskConfigurations', {
  configurations: types.maybeNull(types.array(EntityConfig)),
})

const NotifyDetail = types.model('NotifyDetail', {
  ccMerchFlag: types.maybeNull(types.string),
  customerSet: types.maybeNull(types.string),
  emailId: types.maybeNull(types.string),
  merchantId: types.maybeNull(types.string),
  eventId: types.maybeNull(types.string),
  institutionId: types.maybeNull(types.string),
  mailflag: types.maybeNull(types.string),
  merchantSet: types.maybeNull(types.string),
  mobileNbr: types.maybeNull(types.string),
  notifyFlag: types.maybeNull(types.string),
  notifyLevel: types.maybeNull(types.string),
  pushFlag: types.maybeNull(types.string),
  smsFlag: types.maybeNull(types.string),
  terminalId: types.maybeNull(types.string),
})

const SearchEntity = types.model('SearchEntity', {
  identificationNumber: types.maybeNull(types.string),
  group: types.maybeNull(Group),
  subGroup: types.maybeNull(Group),
  parent: types.maybeNull(Parent),
  child: types.maybeNull(types.array(Child)),
  entity: types.maybeNull(Entity),
  businessProfile: types.maybeNull(BusinessProfile),
  contactDetails: types.maybeNull(types.array(ContactProfile)),
  addressDetails: types.maybeNull(types.array(Address)),
  gstDetails: types.maybeNull(Gst),
  settlementDetails: types.maybeNull(SettlementAccount),
  feePackageDetails: types.maybeNull(FeePackage),
  vpaDetails: types.maybeNull(types.array(Vpa)),
  programCategoryDetails: types.maybeNull(types.array(ProgramDetail)),
  kycDetails: types.maybeNull(types.array(Kyc)),
  terminalDetails: types.maybeNull(types.array(TerminalDetail)),
  deviceDetails: types.maybeNull(types.array(Device)),
  riskSettings: types.maybeNull(RiskConfigurations),
  legalOwnerName: types.maybeNull(types.string),
  merchantLevel: types.maybeNull(types.string),
  unusedMASConfigResponse: types.maybeNull(RiskConfigurations),
  authorisedSignatoryDetails: types.maybeNull(AuthorisedSignatoryDetails),
  notifyDetails: types.maybeNull(types.array(NotifyDetail)),
  beneficialOwnerEntity: types.maybeNull(types.array(BeneficialOwnerEntity)),
  directorEntities: types.maybeNull(types.array(DirectorEntities)),
})

const TenureInterest = types.model('TenureInterest', {
  id: types.optional(types.number, 0),
  tenure: types.optional(types.string, ''),
  interest: types.optional(types.string, ''),
  isSelected: types.optional(types.boolean, false),
})

const Bank = types.model('Bank', {
  id: types.optional(types.string, ''),
  name: types.optional(types.string, ''),
  tenuresInterest: types.optional(types.array(TenureInterest), []),
})

const Emi = types.model('Emi', {
  id: types.optional(types.string, ''),
  type: types.optional(types.string, ''),
  banks: types.optional(types.array(Bank), []),
})

const URL = types.model('URL', {
  type: types.optional(types.string, ''),
  url: types.optional(types.string, ''),
  deleteOnly: types.optional(types.string, ''),
})

const ChannelId = types.model('ChannelId', {
  id: types.optional(types.string, ''),
  deleteOnly: types.maybeNull(types.string),
  configValuesReferenceId: types.maybeNull(types.string),
  key: types.maybeNull(types.string),
  value: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
})

// const CardSubType = types.model('CardSubType', {
//   subType: types.optional(types.string, ''), //Domestic, International, Platinum
//   isSelected: types.optional(types.boolean, false), // Column selected
// })

// const CardScheme = types.model('CardScheme', {
//   scheme: types.optional(types.string, ''), //VISA, Master, Rupay
//   isSelected: types.optional(types.boolean, false), // Row selected
//   Domestic: types.optional(types.boolean, false),
//   International: types.optional(types.boolean, false),
//   Platinum: types.optional(types.boolean, false),
// })

// const Card = types.model('Card', {
//   type: types.optional(types.string, ''), // Debit, Credit, Prepaid
//   isSelected: types.optional(types.boolean, false), // All selected
//   subTypes: types.optional(types.array(CardSubType), CardSubTypes),
//   schemes: types.optional(types.array(CardScheme), []), //VISA, Master, Rupay
// })

const CardType = types.model('CardType', {
  id: types.optional(types.number, -1),
  value: types.optional(types.string, ''),
  isSelected: types.optional(types.boolean, false),
  isChecked: types.optional(types.boolean, false),
})

export const OnboardCardItem = types.model('OnboardCardItem', {
  type: types.optional(types.string, ''),
  scheme: types.optional(types.string, ''),
  description: types.optional(types.string, ''),
  isDomesticAllowed: types.optional(types.boolean, false),
  isInternationalAllowed: types.optional(types.boolean, false),
  isPremium: types.optional(types.boolean, false),
  isSelected: types.optional(types.boolean, false),
})

const ConvenienceFee = types.model('ConvenienceFee', {
  paymentMethod: types.optional(types.string, ''),
  subCategory: types.optional(types.string, ''),
  type: types.optional(types.string, ''),
  percentageValue: types.optional(types.string, ''),
  lowerRange: types.optional(types.string, ''),
  upperRange: types.optional(types.string, ''),
  deleteOnly: types.optional(types.string, ''),
})

const BusinessCategory = types.model('BusinessCategory', {
  businessCategory: types.optional(types.string, ''),
})

const BusinessCategoryMccCode = types.model('BusinessCategoryMccCode', {
  businessLine: types.optional(types.string, ''),
  businessDetails: types.optional(types.array(BusinessCategory), []),
})

const NewCardSchemeSelected = types.model('NewCardSchemeSelected', {
  cardType: types.optional(types.string, ''),
  cardSchemesSelected: types.optional(types.array(types.string), []),
})

const ProfilesAccess = types.model('ProfilesAccess', {
  appProfileId: types.maybeNull(types.number),
  channelId: types.maybeNull(types.string),
  profileName: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
})

const Partner = types.model('Partner', {
  partnerName: types.maybeNull(types.string),
  checkBox: types.maybeNull(types.boolean),
})

const DeviceVariant = types.model('DeviceVariant', {
  id: types.optional(types.string, ''),
  mid: types.optional(types.string, ''),
  tid: types.optional(types.string, ''),
  vpa: types.optional(types.string, ''),
  type: types.optional(types.string, ''),
  deviceid: types.optional(types.string, ''),
  name: types.optional(types.string, ''),
  status: types.optional(types.string, ''),
  createdAt: types.optional(types.string, ''),
  updatedAt: types.optional(types.string, ''),
  oneTimeSetUpFee: types.maybeNull(types.integer),
  monthlyCharges: types.maybeNull(types.integer),
  actionDownload: types.optional(types.string, 'Delete'),
})

const VariantPlanList = types.model('DeviceVariant', {
  id: types.optional(types.string, ''),
  variantRefId: types.string,
  oneTimeFee: types.maybeNull(types.integer),
  recurringFee: types.maybeNull(types.integer),
  mandateRuleAmount: types.maybeNull(types.integer),
  status: types.string,
  actionDownload: types.optional(types.string, 'Delete'),
})

const Onboarding = types
  .model('Onboarding', {
    id: types.optional(types.string, ''),
    vpas: types.optional(types.array(Vpa), []),
    parentMid: types.optional(types.string, ''),
    mid: types.optional(types.string, ''),
    merchantName: types.optional(types.string, ''),
    channelId: types.optional(types.string, ''),
    clientId: types.optional(types.string, ''),
    secretCode: types.optional(types.string, ''),
    s2sUrl: types.optional(types.string, ''),
    integrationType: types.optional(types.string, ''),
    INTEGRATION_TYPE: types.optional(types.string, ''),
    sodexo: types.optional(types.string, ''),
    offers: types.optional(types.string, ''),
    offerComment: types.optional(types.string, ''),
    paymentConfig: types.optional(types.array(PaymentConfig), []),
    searchString: types.optional(types.string, ''),
    cardConfig: types.optional(types.array(CardConfig), []),
    isEmiFileUploaded: types.optional(types.boolean, false),
    isCardsModified: types.optional(types.boolean, false),
    eid: types.optional(types.string, ''),
    entityName: types.optional(types.string, ''),
    upiConfig: UpiConfig,
    isEditMode: types.optional(types.boolean, false),
    bankRPartnerConfig: BankOrPartnerConfig,
    globalSearchString: types.optional(types.string, ''),
    searchFilterBy: types.optional(types.string, 'Entity ID'),
    contactProfiles: types.optional(types.array(ContactProfile), [ContactProfileData]),
    isEMSflow: types.optional(types.boolean, false),
    businessDetail: BusinessDetail,
    //Program details
    programDetails: types.optional(types.array(ProgramDetail), []),
    group: Group,
    subgroup: types.optional(types.array(SubGroup), []),
    groups: types.optional(types.array(Group), []),
    subgroups: types.optional(types.array(Group), []),
    selectedSubGroupId: types.optional(types.string, ''),
    selectedSubGroupName: types.optional(types.string, ''),
    selectedParentEntityId: types.optional(types.string, ''),
    selectedParentEntityName: types.optional(types.string, ''),
    searchEntity: types.optional(types.array(SearchEntity), []),
    subGroupId: types.optional(types.string, ''),
    subGroupName: types.optional(types.string, ''),
    entityDetails: types.optional(SearchEntity, {}),
    terminalDetails: types.optional(types.array(TerminalDetail), []),
    devices: types.optional(types.array(Device), []),
    qrUrl: types.optional(types.string, ''),
    emis: types.optional(types.array(Emi), []),
    emiBankSelected: types.optional(types.string, ''),
    emiTenureSelected: types.optional(types.string, ''),
    subscriptions: types.optional(types.string, ''),
    emiFlag: types.optional(types.string, ''),
    tokenizationFlag: types.optional(types.string, ''),
    collectLink: types.optional(types.string, ''),
    convienienceFee: types.optional(types.string, ''),
    isDebitCardEmiSelected: types.optional(types.boolean, false),
    isCreditCardEmiSelected: types.optional(types.boolean, false),
    isCardlessEmiSelected: types.optional(types.boolean, false),
    merchant: types.optional(Merchant, {}),
    isPresentInMms: types.optional(types.string, ''),
    isAllBanksSelected: types.optional(types.boolean, false),
    isAllPayLaterSelected: types.optional(types.boolean, false),
    isAllWalletSelected: types.optional(types.boolean, false),
    //API config
    isAllPciSelected: types.optional(types.boolean, false),
    isAllCommonPciNonPciSelected: types.optional(types.boolean, false),
    isAllEmisSelected: types.optional(types.boolean, false),
    isAllOthersSelected: types.optional(types.boolean, false),
    isAllCollectLinkSelected: types.optional(types.boolean, false),
    s2sUrls: types.optional(types.array(URL), []),
    collectLinkUrls: types.optional(types.array(URL), []),
    channelIds: types.optional(types.array(ChannelId), []),
    addedchannelIds: types.optional(types.array(ChannelId), []),
    deletedchannelIds: types.optional(types.array(ChannelId), []),
    AES_KEY: types.optional(types.string, ''),
    MAC_KEY: types.optional(types.string, ''),
    CONVENIENCE_MODEL: types.optional(types.string, ''),
    REFUND_TYPE: types.optional(types.string, ''),
    GST_INVOICE_TEMPLATE: types.optional(types.string, ''),
    cardTypes: types.optional(types.array(CardType), newCardTypeDropdownData),
    cardList: types.optional(types.array(OnboardCardItem), []),
    cardSelectedList: types.optional(types.array(OnboardCardItem), []),
    fileUploadProgress: types.optional(types.number, 0),
    convenienceFees: types.optional(types.array(ConvenienceFee), []),
    profilesaccesslist: types.optional(types.array(ProfilesAccess), []),
    entityParentType: types.optional(types.string, ''),
    searchedMasMid: types.optional(types.string, ''),
    configList: types.maybeNull(types.array(Config)),
    createdConfigList: types.optional(types.array(Config), []),
    deletedConfigList: types.optional(types.array(Config), []),
    updateConfigList: types.optional(types.array(Config), []),
    emsParentEntityIdentificationNumber: types.optional(types.string, ''),
    searchApiStatus: types.optional(types.string, ''),
    entityConfigs: types.optional(types.array(EntityConfig), []),
    configurations: types.maybeNull(types.array(Configurations)),
    createdEntityConfigs: types.optional(types.array(EntityConfig), []),
    deletedEntityConfigs: types.optional(types.array(EntityConfig), []),
    businessCategoryMccCodeList: types.optional(types.array(BusinessCategoryMccCode), []),
    saveEnteredContactProfile: types.optional(types.boolean, false),
    saveEnteredBusinessDetails: types.optional(types.boolean, false),
    isSyncDone: types.optional(types.boolean, false),
    updatedEntityConfigs: types.optional(types.array(EntityConfig), []),
    isViewDetailsSearchFlow: types.optional(types.boolean, false),
    partners: types.optional(types.array(Partner), []),
    updatedPartners: types.optional(types.boolean, false),
    hasCardsChanged: types.optional(types.boolean, false),
    uploadId: types.optional(types.string, ''),
    deviceVariantList: types.optional(types.array(DeviceVariant), []),
    assignedDevicesList: types.optional(types.array(DeviceVariant), []),
    variantPlanList: types.optional(types.array(VariantPlanList), []),
  })
  .actions((self) => ({
    resetUploadId() {
      self.uploadId = ''
    },
    setCardsChange(isChanged: boolean) {
      self.hasCardsChanged = isChanged
    },
    setViewDetailsSearchFlow(isViewDetailsSearch: boolean) {
      self.isViewDetailsSearchFlow = isViewDetailsSearch
    },
    resetDataEntered() {
      self.saveEnteredBusinessDetails = false
      self.saveEnteredContactProfile = false
      self.searchedMasMid = ''
      self.selectedParentEntityId = ''
      self.selectedParentEntityName = ''
      self.selectedSubGroupId = ''
      self.selectedSubGroupName = ''
      self.emsParentEntityIdentificationNumber = ''
      self.contactProfiles = JSON.parse(JSON.stringify([ContactProfileData]))
      self.subGroupId = ''
      self.subGroupName = ''
      self.entityParentType = ''
      self.group = {}
      self.businessDetail = {}
    },
    saveBusinessData(isSave: boolean) {
      self.saveEnteredBusinessDetails = isSave
    },
    saveContactProfileData(isSave: boolean) {
      self.saveEnteredContactProfile = isSave
    },
    saveState(): void {
      initialState = getSnapshot(self)
    },
    resetState(): void {
      try {
        applySnapshot(self, initialState)
      } catch (e) {
        RootStore.message.handleError(e)
      }
    },
    resetQrTransactionPattern() {
      self.upiConfig.qrTxnPattern = ''
    },
    pushItemContactProfiles(id: string) {
      let contactProfileData: any = {
        id: +id,
        mobileNumber: '',
        firstName: '',
        lastName: '',
        dob: '',
        gender: '',
        emailId: '',
        phone1: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        pincode: '',
        role: '',
        allowNotification: '',
      }
      if (!self.contactProfiles.includes(contactProfileData)) {
        self.contactProfiles.push(contactProfileData)
      }
    },
    deleteContactProfiles(_id: number) {
      if (self?.contactProfiles?.length > 1) {
        self?.contactProfiles?.pop()
      }
    },
    addToCreateConfigurationsList(configType: string, key: string, value: string, isChecked: boolean) {
      if (self?.configurations?.length > 0 && self.configurations.filter((e) => e.key === key).length === 0) {
        if (self.createdEntityConfigs.filter((c) => c.configType === configType).length === 0) {
          self.createdEntityConfigs.push({
            configType: configType,
            configValues: [
              {
                key: key,
                value: value,
                status: 'ACTIVE',
              },
            ],
          })
        } else {
          self.createdEntityConfigs.map((conf) => {
            if (conf.configType === configType) {
              if (conf.configValues.filter((c) => c.key === key).length === 0) {
                conf.configValues.push({
                  key: key,
                  value: value,
                  status: 'ACTIVE',
                })
              } else {
                conf.configValues.map((confValue) => {
                  if (confValue.key === key) {
                    return {
                      ...confValue,
                      value: value,
                    }
                  }
                })
              }
            }
          })
        }
      } else {
        if (!checkIfConfigPresentInUpdatedEntityConfigs(self.updatedEntityConfigs, configType, key)) {
          const { refId } = getRefIdValue(key, configType, self.configurations)
          if (refId?.length > 0) {
            self.updatedEntityConfigs.push({
              configType: configType,
              configValues: [
                {
                  key: key,
                  value: value,
                  status: 'ACTIVE',
                  configValuesReferenceId: refId,
                },
              ],
            })
          }
        } else {
          for (let j = 0; j < self.updatedEntityConfigs.length; j++) {
            if (self.updatedEntityConfigs[j].configType === configType) {
              for (let i = 0; i < self.updatedEntityConfigs[j].configValues.length; i++) {
                if (self.updatedEntityConfigs[j].configValues[i].key === key) {
                  const { refId } = getRefIdValue(key, configType, self.configurations)
                  self.updatedEntityConfigs[j] = {
                    configType: configType,
                    configValues: [
                      {
                        key: key,
                        value: value,
                        status: 'ACTIVE',
                        configValuesReferenceId: refId,
                      },
                    ],
                  }
                }
              }
            }
          }
        }
      }
    },
    deleteConfigurationsList(configType: string, key: string, value: string, configValuesReferenceId: string) {
      console.log('dinesh deleteConfigurationsList is called')
      if (self.deletedEntityConfigs.filter((e) => e.configType === configType).length === 0) {
        self.deletedEntityConfigs.push({
          configType: configType,
          configValues: [
            {
              key: key,
              value: value,
              configValuesReferenceId: configValuesReferenceId,
              status: 'ACTIVE',
            },
          ],
        })
      } else {
        self.deletedEntityConfigs.map((d) => {
          if (d.configType === configType) {
            d.configValues.push({
              key: key,
              value: value,
              configValuesReferenceId: configValuesReferenceId,
              status: 'ACTIVE',
            })
          }
        })
      }
    },
    addAllToConfigList(key: string, value: string, isAllSelected: boolean) {
      if (isAllSelected) {
        if (
          self?.configList &&
          self?.configList?.length > 0 &&
          self?.configList.filter((e) => e.key === key && e.value === value).length === 0
        ) {
          if (self.createdConfigList.filter((e) => e.key === key && e.value === value).length === 0) {
            self.createdConfigList.push({
              key: key,
              value: value,
            })
          }
        } else {
          self.createdConfigList.push({
            key: key,
            value: value,
          })
        }
        if (self.deletedConfigList.filter((c) => c.key === key && c.value === value).length !== 0) {
          self.deletedConfigList = JSON.parse(
            JSON.stringify(self.deletedConfigList.filter((cf) => cf.key !== key && cf.value !== value)),
          )
        }
      } else {
        if (self.createdConfigList.length > 0) {
          self.createdConfigList.clear()
        }
      }
    },
    addPartnerToConfigList(key: string, value: string, status: string) {
      if (
        (self.configList &&
          self.configList.length > 0 &&
          self.configList.filter((e) => e.key === key && e.value === value).length === 0) ||
        self.configList === null
      ) {
        if (self.createdConfigList.filter((conf) => conf.key === key && conf.value === value).length === 0) {
          self.createdConfigList.push({
            key: key,
            value: value,
            status: status,
          })
        } else {
          self.createdConfigList.map((conf) => {
            if (conf.key === key) {
              conf.value = value
              conf.status = status
              return conf
            }
          })
        }
      }
    },

    removePartnerFromCreatedConfigList(key: string, value: string, status: string) {
      if (
        self?.createdConfigList?.filter((conf) => conf?.key === key && conf?.value === value && conf?.status === status)
          .length === 1
      ) {
        self.createdConfigList = JSON.parse(
          JSON.stringify(
            self?.createdConfigList?.filter(
              (conf) => conf?.key !== key && conf?.value !== value && conf?.status !== status,
            ),
          ),
        )
      }
    },
    addToConfigList(key: string, value: string, isPaymentInstSelected: boolean) {
      if (
        key !== 'SUPPORTED_NETBANKING' &&
        key !== 'SUPPORTED_PAYLATER' &&
        key !== 'SUPPORTED_WALLET' &&
        key !== 'SUPPORTED_CORPORATENETBANKING' &&
        ((self.configList && self.configList.length > 0 && self.configList.filter((e) => e.key === key).length === 0) ||
          self.configList === null)
      ) {
        if (self.createdConfigList.filter((conf) => conf.key === key).length === 0) {
          self.createdConfigList.push({
            key: key,
            value: value,
          })
        } else {
          self.createdConfigList.map((conf) => {
            if (conf.key === key) {
              conf.value = value
              return conf
            }
          })
        }
      } else {
        if (
          key === 'SUPPORTED_NETBANKING' ||
          key === 'SUPPORTED_PAYLATER' ||
          key === 'SUPPORTED_WALLET' ||
          key === 'SUPPORTED_CORPORATENETBANKING'
        ) {
          if (self.createdConfigList.filter((conf) => conf.key === key).length === 0) {
            self.createdConfigList.push({
              key: key,
              value: value,
            })
          } else {
            if (isPaymentInstSelected) {
              self.createdConfigList.push({
                key: key,
                value: value,
              })
            } else {
              //To remove already selected and pushed on its deselection
              self.createdConfigList = JSON.parse(
                JSON.stringify(self.createdConfigList.filter((conf) => conf.value !== value)),
              )
            }
          }
        }
      }
    },
    updateTheConfigList(key: string, value: string, configValuesReferenceId: string, status?: string) {
      if (self.updateConfigList.filter((e) => e.key === key).length === 0) {
        self.updateConfigList.push({
          key: key,
          value: value,
          configValuesReferenceId: configValuesReferenceId,
          ...(status && status?.length > 0 && { status: status }),
        })
      } else {
        self.updateConfigList.map((updateconf) => {
          if (updateconf.key === key) {
            updateconf.value = value
            updateconf.configValuesReferenceId = configValuesReferenceId
            if (status && status?.length > 0) {
              updateconf.status = status
            }
            return updateconf
          }
        })
      }
    },
    updateThePartnerConfigList(key: string, value: string, configValuesReferenceId: string, status: string) {
      if (self.updateConfigList.filter((e) => e.key === key && e.value === value).length === 0) {
        self.updateConfigList.push({
          key: key,
          value: value,
          configValuesReferenceId: configValuesReferenceId,
          status: status,
        })
      } else {
        if (
          self.configList.filter(
            (orgConf) => orgConf.key === key && orgConf.value === value && orgConf.status === status,
          ).length === 1
        ) {
          self.updateConfigList = JSON.parse(
            JSON.stringify(
              self.updateConfigList.filter((cf) => cf.key !== key && cf.value !== value && cf.status !== status),
            ),
          )
        } else {
          self.updateConfigList.map((updateconf) => {
            if (updateconf.key === key) {
              updateconf.value = value
              updateconf.configValuesReferenceId = configValuesReferenceId
              updateconf.status = status
              return updateconf
            }
          })
        }
      }
    },
    updatePartnerConfig(type: any, value: any, isChecked: boolean) {
      self.updatedPartners = false
      for (let i = 0; i < self.partners.length; i++) {
        if (self.partners?.[i]?.partnerName === value) {
          const updatedObj = { partnerName: self.partners[i].partnerName, checkBox: isChecked }
          self.partners.splice(i, 1, updatedObj)
        }
      }
      if (checkIsPartnerConfigPresent(type, value, self.configList)) {
        // Update existing  bank partner config case
        ;(self as any).updateThePartnerConfigList(
          type,
          value,
          getRefIdForPaymentInstruments(type, value, self.configList),
          isChecked ? 'ACTIVE' : 'INACTIVE',
        )
      } else {
        // Create new bank partner config case
        if (value) {
          if (isChecked) {
            ;(self as any).addPartnerToConfigList(type, value, 'ACTIVE')
          } else {
            //To remove unchecked banks after checking it
            ;(self as any).removePartnerFromCreatedConfigList(type, value, 'ACTIVE')
          }
        }
      }
      self.updatedPartners = true
      console.log('self.partners', JSON.parse(JSON.stringify(self.partners)))
    },
    deleteConfigList(key: string, value: string, configValuesReferenceId: string, isSelected: boolean) {
      if (isSelected) {
        if (self.deletedConfigList.filter((delConf) => delConf.key === key && delConf.value === value).length !== 0) {
          if (self.configList.filter((conf) => conf.key === key && conf.value === value).length !== 0) {
            for (let i = 0; i < self.deletedConfigList.length; i++) {
              if (self.deletedConfigList[i].key === key && self.deletedConfigList[i].value === value) {
                self.deletedConfigList.splice(i, 1)
              }
            }
          }
        }
      } else {
        if (self.deletedConfigList.filter((delConf) => delConf.key === key && delConf.value === value).length === 0) {
          if (self.configList.filter((conf) => conf.key === key && conf.value === value).length !== 0) {
            self.deletedConfigList.push({
              key: key,
              value: value,
              configValuesReferenceId: configValuesReferenceId,
              // status: 'ACTIVE',
            })
          }
        }
        if (self.createdConfigList.filter((c) => c.key === key && c.value === value).length !== 0) {
          self.createdConfigList = JSON.parse(
            JSON.stringify(self.createdConfigList.filter((cf) => cf.key !== key && cf.value !== value)),
          )
        }
      }
    },
    resetCreateSingleEntitySelections() {
      self.searchedMasMid = ''
      self.selectedParentEntityId = ''
      self.selectedParentEntityName = ''
      self.selectedSubGroupId = ''
      self.selectedSubGroupName = ''
      self.emsParentEntityIdentificationNumber = ''
      self.subGroupId = ''
      self.entityParentType = ''
      self.group = {}
      self.saveEnteredBusinessDetails = false
      self.saveEnteredContactProfile = false
      self.isViewDetailsSearchFlow = false
    },
    searchMerchantWithMid: flow(function* searchMerchantWithMid(mid: string) {
      try {
        const response = yield getMerchantWithMid(mid, RootStore.session.getTokens)
        if (response.status === 'SUCCESS') {
          self.merchant.terminals = response?.response?.terminals
          self.merchant.profile = response?.response?.profile
          self.isPresentInMms = response?.response?.isPresentInMms
          self.merchant.merchantId = mid
          self.mid = mid
        }
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    fetchVpas: flow(function* fetchVpas() {
      try {
        const response = yield getAllVpas(RootStore.session.getTokens)
        self.vpas = response
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    updateParentMid(mid: any) {
      const own = self
      own.parentMid = mid
    },
    updateMercName(name: any) {
      const own = self
      own.merchantName = name
    },
    updateGeneralConfigs(type: any, value: any) {
      const own: any = self
      own[type] = value
      if (type === 'AES_KEY' || type === 'MAC_KEY') {
        ;(self as any).addToCreateConfigurationsList('KEYS', type, value)
      }
    },
    saveData: flow(function* saveData(step: number) {
      const mmsReqBody = {
        paretMid: self.parentMid,
        mid: self.mid,
      }
      const apiReqBody = {
        merchantName: self.merchantName,
        mid: self.mid,
      }
      const getReq: any = {
        // 1: mmsReqBody,
        1: apiReqBody,
      }
      try {
        const resp = yield saveOnboardingData(getReq[step] ?? mmsReqBody, RootStore.session.getTokens)
        if (step === 1) {
          self.channelId = resp?.channelId ?? ''
          self.clientId = resp?.clientId ?? ''
          self.secretCode = resp?.secretCode ?? ''
        }
        return resp
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    saveEmiInfo: flow(function* saveEmiInfo(emiData: any[]) {
      const errorData: any[] = []
      for (let i = 0; i < emiData.length; i++) {
        try {
          const response = yield saveEmiConfig(RootStore.session.getTokens)
          errorData.push(response)
        } catch (e) {
          RootStore.message.setMessage(getErrorMessage(e), MessageTypes.ERROR)
          throw e
        }
      }
      return errorData
    }),
    getPaymentConfigData() {
      return self.paymentConfig
    },
    updateSelection(id: number) {
      self.paymentConfig.map((item) => {
        if (item.id === id) {
          item.isSelected = true
        } else {
          item.isSelected = false
        }
      })
    },
    updateChecked(id: number, isChecked: boolean, isFromSearchApiResponse?: boolean) {
      const own: any = self
      self.paymentConfig.map((item) => {
        if (item.id === id) {
          if (!isFromSearchApiResponse) {
            if (!item.isChecked) {
              own.addToCreateConfigurationsList('PAYMENT_ACCEPTANCE', getPayAcceptanceKey(item.name), 'Y', isChecked)
            } else {
              const key = getPayAcceptanceKey(item.name)
              const { refId, value } = getRefIdValue(key, 'PAYMENT_ACCEPTANCE', self.configurations)
              own.deleteConfigurationsList('PAYMENT_ACCEPTANCE', key, value, refId)
            }
          }
          item.isChecked = isChecked
        }
      })
    },
    updateUpiConfigs(type: any, value: any) {
      console.log('updateUpiConfigs', type, value)
      const exactKey = getExactConfigKey(type)
      const realValue = typeof value === 'boolean' ? (value ? 'Y' : 'N') : value
      if (checkIsConfigPresent(exactKey, realValue, self.configList)) {
        ;(self as any).updateTheConfigList(exactKey, realValue, getUpiRefId(exactKey, value, self.configList))
      } else {
        if (realValue) {
          ;(self as any).addToConfigList(exactKey, realValue)
        }
      }
      self.upiConfig[type] = value
      // self.paymentConfig.map((item) => {
      //   if (item.id === 1 && typeof value === 'boolean') {
      //     item.isChecked = value
      //   }
      // })
    },
    updateEditMode(isEdit: boolean) {
      self.isEditMode = isEdit
    },
    updateBankOrPartnerConfigs(type: string, value: string) {
      self.bankRPartnerConfig[type] = value
    },
    updateGlobalSearchString(str: string) {
      self.globalSearchString = str
    },
    setSearchFilterBy(filterBy: string) {
      self.searchFilterBy = filterBy
    },
    addContactProfile(id: number, key: string, value: string) {
      self.contactProfiles.map((item) => {
        if (item.id === id) {
          item[key] = value
        }
        return item
      })
    },
    checkIsUniqueContactNumber(id: string, key: string, value: string) {
      if (key === 'mobileNumber' && self.contactProfiles.length > 1 && value && value.length > 0) {
        for (let i = 0; i < self.contactProfiles.length; i++) {
          const item = self.contactProfiles[i]
          if (item.mobileNumber === value && item.id < id) {
            return false
          }
        }
      }
      return true
    },
    setEmsFlow(isEMSFlow: boolean) {
      self.isEMSflow = isEMSFlow
    },
    resetFeePkgId() {
      self.businessDetail.mdrPackageId = ''
    },
    updateBusinessDetails(values: any, type: string) {
      console.log('updateBusinessDetails values', values)
      self.businessDetail.emType = type
      Object.keys(values).map((key) => {
        self.businessDetail[key] = `${values[key]}`
      })
    },
    updateBusinessDetail(key: string, value: string) {
      console.log('updateBusinessDetail key value', key, value)
      if (key === 'mdrPackageId') {
        self.businessDetail[key] = `${value}`
      } else {
        self.businessDetail[key] = value
      }
    },
    setGroupSelected(data: any) {
      self.group.groupId = data?.groupId ?? ''
      self.group.groupName = data?.groupName ?? data?.brandName ?? data?.legalName ?? ''
    },
    setEntityGrpIdSelected(data: any) {
      self.selectedSubGroupId = data?.groupId
      self.selectedSubGroupName = data?.brandName ?? data?.groupName ?? data?.businessName
    },
    setParentEntityIdSelected(data: any) {
      self.selectedParentEntityName = data?.brandName ?? data?.businessName
      self.selectedParentEntityId = data?.identificationNumber ?? data?.groupId ?? data?.masMid
    },
    setSubGroupSelectedData(data: any) {
      self.subGroupId = data?.identificationNumber
      self.subGroupName = data?.brandName ?? data?.groupName ?? data?.businessName
    },
    updateGstConsent(type: string, value: boolean) {
      self.upiConfig.gstConfig.gstConsent = value
    },
    addGstNumber(id: string, gstNumber: string, isDefault: boolean) {
      const newGst = { id, gstNumber, isDefault }
      self.upiConfig.gstConfig.gstNumbers.push(GstNumber.create(newGst))
    },
    deleteGstNumber(id: string) {
      self.upiConfig.gstConfig.gstNumbers.map((gst) => {
        if (gst.id === id) {
          self.upiConfig.gstConfig.gstNumbers.remove(gst)
        }
      })
      self.upiConfig.gstConfig.gstNumbers.map((gst, index) => {
        gst.id = `${index + 1}`
      })
    },
    updateDefaultGst(id: string) {
      self.upiConfig.gstConfig.gstNumbers.map((gst) => {
        if (gst.id === id) {
          gst.isDefault = true
        } else {
          gst.isDefault = false
        }
      })
    },
    updatGstNumber(id: string, gstNumber: string) {
      self.upiConfig.gstConfig.gstNumbers.map((gst) => {
        if (gst.id === id) {
          gst.gstNumber = gstNumber
        }
      })
    },
    updateSelectedEmis(id: string, type: string, isChecked: boolean) {
      self.emis.map((emi) => {
        if (emi.type === type) {
          emi.banks.map((bank) => {
            bank.tenuresInterest.map((tenuresInterest) => {
              if (tenuresInterest.id === +id) {
                tenuresInterest.isSelected = isChecked
              }
            })
          })
        }
      })
    },
    updateAllSelectedByType(type: string, isChecked: boolean) {
      if (type === 'debit') {
        self.isDebitCardEmiSelected = isChecked
      } else if (type === 'credit') {
        self.isDebitCardEmiSelected = isChecked
      } else if (type === 'cardless') {
        self.isCardlessEmiSelected = isChecked
      }
      self.emis.map((emi) => {
        // if (emi.type === type) {
        emi.banks.map((bank) => {
          bank.tenuresInterest.map((tenuresInterest) => {
            tenuresInterest.isSelected = isChecked
          })
        })
        // }
      })
    },
    updateSelectedTenureOfEmi(tenure: string) {
      self.emiTenureSelected = tenure
    },
    updateSelectedEmiBank(bank: string) {
      self.emiBankSelected = bank
    },
    getMerchantQrByVpas: flow(function* getMerchantQrByVpas(mid: string, vpas: string[]) {
      try {
        const own = self
        const response = yield getMerchantQrByVpa(mid, vpas, RootStore.session.getTokens)
        console.log('getMerchantQrByVpas: ', response)
        own.merchant.terminals.map((terminal) => {
          response?.map((qrDetail: { vpa: string; qr: string }) => {
            if (terminal.businessVPA === qrDetail?.vpa) {
              terminal.qrUrl = qrDetail?.qr
            }
          })
        })
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    getDevicesListAsync: flow(function* getDevicesListAsync(type: String) {
      try {
        const response = yield getDeviceVariantListApi(type, RootStore.session.getTokens)
        console.log('getDevicesListAsync: ', response)
        self.deviceVariantList = response?.data
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    getAssignedDevicesToMidAsync: flow(function* getAssignedDevicesToMidAsync(mid: String) {
      try {
        const response = yield getAssignedDevicesToMidApi(mid, RootStore.session.getTokens)
        console.log('getDevicesListAsync: ', response)
        self.assignedDevicesList = response?.data
        return response
      } catch (error) {
        self.assignedDevicesList = []
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    getVariantPlanListAsync: flow(function* getVariantPlanListAsync(variantId: String) {
      try {
        const response = yield getVariantPlanListApi(variantId, RootStore.session.getTokens)
        console.log('getDevicesListAsync: ', response)
        self.variantPlanList = response?.data
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    deleteDeviceVariantAsync: flow(function* deleteDeviceVariantAsync(id: String) {
      try {
        const response = yield deleteDeviceVariantApi(id, RootStore.session.getTokens)
        console.log('deleteDeviceVariantAsync: ', response)
        RootStore.message.setMessage('Device variant deleted sucessfully', MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    deleteDevicePlanAsync: flow(function* deleteDevicePlanAsync(id: String) {
      try {
        const response = yield deleteDevicePlanApi(id, RootStore.session.getTokens)
        console.log('deleteDeviceVariantAsync: ', response)
        RootStore.message.setMessage('Device variant deleted sucessfully', MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    addNewDeviceVariantAsync: flow(function* addNewDeviceVariantAsync(variantName: String, type: String) {
      try {
        const response = yield addDeviceVariantApi(variantName, type, RootStore.session.getTokens)
        console.log('addDeviceVariantApi: ', response)
        RootStore.message.setMessage('Device variant added sucessfully', MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    addNewDevicePlanAsync: flow(function* addNewDevicePlanAsync(addPlanReq: any) {
      try {
        const response = yield addDevicePlanApi(addPlanReq, RootStore.session.getTokens)
        console.log('addDeviceVariantApi: ', response)
        RootStore.message.setMessage('Device variant added sucessfully', MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    onboardInsertMerchant: flow(function* onboardInsertMerchant(merchantData: MerchantData) {
      try {
        const response = yield insertMerchant(merchantData, RootStore.session.getTokens)
        self.mid = response?.mid
        self.channelId = response?.channelId
        console.log('onboardInsertMerchant: ', response)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    addUrls(type: string, subType: string, url: string) {
      const own = self
      if (type === 's2sUrls') {
        own.s2sUrls = [...own.s2sUrls, { type: subType, url: url, deleteOnly: 'deleteOnly' }]
      } else if (type === 'collectLinkUrls') {
        own.collectLinkUrls = [...own.collectLinkUrls, { type: subType, url: url, deleteOnly: 'deleteOnly' }]
      }
    },
    addChannelIds(id: string) {
      const own = self
      own.channelIds = [...own.channelIds, { value: id, deleteOnly: 'deleteOnly' }]
      own.addedchannelIds = [...own.addedchannelIds, { key: 'ALLOWED_CHANNEL', value: id }]
    },
    updateQrUrlToTerminal(tid: string, vpa: string, qrUrl: string) {
      const own = self
      own.merchant.terminals.filter((terminal) => {
        if (terminal.terminalID === tid) {
          terminal.businessVPA = `${vpa}`
          terminal.qrUrl = `${qrUrl}`
        }
      })
    },
    deleteUrlByType(urlType: string, type: string) {
      const own = self
      if (urlType === 's2sUrls') {
        own.s2sUrls.map((s2s) => {
          if (s2s.type === type) {
            own.s2sUrls.remove(s2s)
          }
        })
      } else if (urlType === 'collectLinkUrls') {
        own.collectLinkUrls.map((collink) => {
          if (collink.type === type) {
            own.collectLinkUrls.remove(collink)
          }
        })
      } else if (urlType === 'channelIds') {
        own.channelIds.map((channelId) => {
          if (channelId.value === type) {
            own.channelIds.remove(channelId)
            own.deletedchannelIds = [
              ...own.deletedchannelIds,
              {
                key: 'ALLOWED_CHANNEL',
                value: channelId.value,
                configValuesReferenceId: channelId.configValuesReferenceId,
              },
            ]
          }
        })
      }
    },
    createVpaOnChangeJioPartner: flow(function* createVpaOnChangeJioPartner(merchantData: MerchantData) {
      try {
        const response = yield createVpa(merchantData, RootStore.session.getTokens)
        console.log('createVpaOnChangeJioPartner: ', response)
        if (response === 'SUCCESS') {
          const own = self
          for (let i = 0; i < own.merchant.terminals.length; i++) {
            let terminal = own.merchant.terminals[i]
            if (terminal.terminalID === merchantData?.terminalId) {
              const updatedVpa = merchantData?.vpa.replace('JioPartner', 'JioPay')
              terminal = { ...terminal, businessVPA: updatedVpa }
              own.merchant.terminals[i] = terminal
              break
            }
          }
        }
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    generateNewQrUrl: flow(function* generateNewQrUrl(merchantData: MerchantData) {
      try {
        const own = self
        const response = yield generateQr(merchantData, RootStore.session.getTokens)
        console.log('generateNewQrUrl: ', response)
        for (let i = 0; i < own.merchant.terminals.length; i++) {
          let terminal = own.merchant.terminals[i]
          if (terminal.businessVPA === merchantData?.vpa) {
            terminal.qrUrl = `${response}`
            break
          }
        }
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    resetSelectionsDataOnSubmit() {
      self.id = ''
      self.vpas = []
      self.parentMid = ''
      self.mid = ''
      self.merchantName = ''
      self.channelId = ''
      self.clientId = ''
      self.secretCode = ''
      self.s2sUrl = ''
      self.integrationType = ''
      self.INTEGRATION_TYPE = ''
      self.sodexo = ''
      self.offers = ''
      self.offerComment = ''
      self.paymentConfig = PaymentConfigData
      self.searchString = ''
      self.cardConfig = []
      self.isEmiFileUploaded = false
      self.isCardsModified = false
      self.eid = ''
      self.entityName = ''
      self.upiConfig = {}
      self.isEditMode = false
      self.bankRPartnerConfig = {}
      self.globalSearchString = ''
      self.searchFilterBy = 'Entity ID'
      self.contactProfiles = []
      self.isEMSflow = false
      self.businessDetail = {}
      //Program details
      self.programDetails = []
      self.group = {}
      self.selectedSubGroupId = ''
      self.selectedParentEntityId = ''
      self.searchEntity = []
      self.evices = []
      self.qrUrl = ''
      self.emis = []
      self.emiBankSelected = ''
      self.emiTenureSelected = ''
      self.subscriptions = ''
      self.emiFlag = ''
      self.tokenizationFlag = ''
      self.collectLink = ''
      self.convienienceFee = ''
      self.isDebitCardEmiSelected = false
      self.isCreditCardEmiSelected = false
      self.isCardlessEmiSelected = false
      self.merchant = {}
      self.isPresentInMms = 'false'
      self.isAllBanksSelected = false
      self.isAllPayLaterSelected = false
      self.isAllWalletSelected = false
      self.isAllPciSelected = false
      self.isAllCommonPciNonPciSelected = false
      self.isAllEmisSelected = false
      self.isAllOthersSelected = false
      self.s2sUrls = []
      self.collectLinkUrls = []
      self.channelIds = []
      self.AES_KEY = ''
      self.MAC_KEY = ''
      self.CONVENIENCE_MODEL = ''
      self.REFUND_TYPE = ''
      self.GST_INVOICE_TEMPLATE = ''
      self.subGroupId = ''
      self.subGroupName = ''
      self.group = {}
      self.hasCardsChanged = false
    },
    setFileUploadProgress(progress: number): void {
      const own = self
      own.fileUploadProgress = progress
    },
    uploadBulkEntitiesFile: flow(function* uploadBulkEntitiesFile(fileName: string, fileSize: string, file: any) {
      let res
      try {
        res = yield uploadBulkEntitiesFileReq(fileName, fileSize, RootStore.user.session.getTokens, file)
        const errorCode = res?.error?.code ?? ''
        console.log({ errorCode })
        if (errorCode === '33607' || errorCode === '33306') {
          if (errorCode === '33607') {
            extendUserSessionAPI().then((response) => {
              console.log('extendUserSessionAPI response', response)
              return (self as any).uploadBulkEntitiesFile(fileName, fileSize, file)
            })
          } else {
            extendAppSessionAPI().then((response) => {
              console.log('extendAppSessionAPI response', response)
              return (self as any).uploadBulkEntitiesFile(fileName, fileSize, file)
            })
          }
        }
        if (res?.status === 'FAILED') {
          // TODO: show error based on code
          // self.uploadStatus = 'NOT_SELECTED'
          RootStore?.response?.setMessage(
            'Invalid file selected, Please download sample file and upload in same format',
          )
        } else if (res?.status === 'INITIATED') {
          // self.uploadedFileId = res?.id
          // self.uploadStatus = 'UPLOADED'
          // self.count = res?.count ?? null
        }
      } catch (e) {
        RootStore?.response?.setMessage(e?.data?.error?.message)
      }
      return res
    }),
    onBoardDevicesAsync: flow(function* onBoardDevicesAsync(onBoardDeviceRequests: any[]) {
      for (let i = 0; i < onBoardDeviceRequests.length; i++) {
        try {
          const response = yield addVariantMasterApi(onBoardDeviceRequests[i], RootStore.session.getTokens)
          onBoardDeviceRequests[i].status = response?.status ?? 'FAILED'
          onBoardDeviceRequests[i].Response = JSON.stringify(response)
        } catch (err) {
          onBoardDeviceRequests[i].status = 'FAILED'
          onBoardDeviceRequests[i].Response = JSON.stringify(err?.data ?? err?.message)
        }
      }
      console.log('final=', onBoardDeviceRequests)
      return onBoardDeviceRequests
    }),
    addConvenienceFee(
      paymentMethod: string,
      subCategory: string,
      type: string,
      percentageValue: string,
      lowerRange: string,
      upperRange: string,
    ) {
      const newConvFee = {
        paymentMethod,
        subCategory,
        type,
        percentageValue,
        lowerRange,
        upperRange,
        deleteOnly: '',
      }
      self.convenienceFees.push(ConvenienceFee.create(newConvFee))
    },
    deleteConvenienceFeeRow(data: any) {
      self.convenienceFees.remove(data)
    },
    addProgramDetail(entityId: string, isEditMode: boolean, id: string, category: string, referenceId: string) {
      if (referenceId.length > 0 && category.length > 0) {
        const newRecord = {
          programId: category,
          id: category,
          category: category,
          referenceId: referenceId,
        }
        if (
          self.programDetails.filter((prog) => prog.category === category && prog.referenceId === referenceId)
            .length === 0
        ) {
          self.programDetails.push(ProgramDetail.create(newRecord))
        }
        if (isEditMode) {
          self.searchEntity.map((data) => {
            if (data?.entity?.identificationNumber === entityId) {
              if (
                data?.entity?.programCategoryDetails.filter(
                  (prog) => prog?.category === category && prog?.referenceId === referenceId,
                ).length === 0
              ) {
                data?.entity?.programCategoryDetails?.push(newRecord)
              }
            }
          })
        }
      }
    },
    deleteProgramDetailRow(item: any, entityId: string) {
      if (entityId.length === 0) {
        self.programDetails.map((program) => {
          if (program.category === item.programCategory && program.referenceId === item.referenceId) {
            self.programDetails.remove(program)
          }
        })
      } else {
        self.searchEntity.map((data) => {
          if (data?.entity?.identificationNumber === entityId) {
            data?.entity?.programCategoryDetails?.map((prog) => {
              if (prog.referenceId === item.referenceId) {
                data?.entity?.programCategoryDetails?.remove(prog)
                self.programDetails = JSON.parse(JSON.stringify(data.entity.programCategoryDetails))
              }
            })
          }
        })
      }
    },
    updateProfileAccessList(access: any, isAccessProvided: boolean) {
      if (isAccessProvided) {
        self.profilesaccesslist = [...self.profilesaccesslist, access]
      } else {
        if (
          self.profilesaccesslist?.length > 0 &&
          self.profilesaccesslist.filter((profile) => profile?.appProfileId === access?.appProfileId)?.length > 0
        ) {
          self.profilesaccesslist.map((profile) => {
            if (profile.appProfileId !== access?.appProfileId) {
              return profile
            }
          })
        }
      }
    },
    setParentTypeSelectedToStore(parentType: string) {
      self.entityParentType = parentType
    },
    setSearchedMasMid(masMid: string) {
      self.searchedMasMid = masMid
    },
    setEmsParentEntityId(id: string) {
      self.emsParentEntityIdentificationNumber = id
    },
    setSearchApiStatus(status: string) {
      self.searchApiStatus = status
    },
    resetSubGroupSelectedName() {
      self.subGroupName = ''
    },
  }))
  .views((self) => ({
    getPartnersList() {
      return self.partners
    },
    getValueFromConfigurations(key: string, configType: string) {
      let value = ''
      if (self.configurations && self.configurations.length > 0) {
        self.configurations.map((config) => {
          if (config.key === key && config.configType === configType) {
            value = config.value
          }
        })
      }
      return value
    },
    getOwnChannelId() {
      let ownChannelId = ''
      if (
        self?.configList?.length > 0 &&
        self?.configList?.filter((config) => config.key === 'OWN_CHANNEL')?.[0]?.value
      ) {
        ownChannelId = self?.configList?.filter((config) => config.key === 'OWN_CHANNEL')?.[0]?.value
      }
      return ENABLE_DUMMY_OWN_CHANNEL_ID ? '329339775323' : ownChannelId
    },
    isConfigHasOwnChannelId() {
      if (
        self?.configList?.length > 0 &&
        self?.configList?.filter((config) => config.key === 'OWN_CHANNEL')?.[0]?.value?.length > 0
      ) {
        return true
      } else {
        return ENABLE_DUMMY_OWN_CHANNEL_ID ? true : false
      }
    },
    getGroupsListFetched() {
      return self.subgroups
    },
    getCreationDataByStep(step: number) {
      if (step === 1) {
        return {
          selectedSubGroupId: self.selectedSubGroupId,
          selectedSubGroupName: self.selectedSubGroupName,
          selectedParentEntityId: self.selectedParentEntityId,
          selectedParentEntityName: self.selectedParentEntityName,
          emsParentEntityIdentificationNumber: self.emsParentEntityIdentificationNumber,
          entityParentType: self.entityParentType,
          searchedMasMid: self.searchedMasMid,
          subGroupListSelectedId: self.subGroupId,
          subGroupListSelectedName: self.subGroupName,
        }
      }
    },
    getProgramCategoryLengthFromSearchEntity(entityId: string) {
      let length = 0
      self.searchEntity.map((data) => {
        if (data?.entity?.identificationNumber === entityId) {
          length = data?.entity?.programCategoryDetails?.length
        }
      })
      return length
    },
    getMccCodeByCategory(category: string) {
      return self.businessCategoryMccCodeList.filter((data) => data.description.includes(category))?.[0]?.mccCode
    },
    getCardsTypeList() {
      return self.cardTypes
    },
    getApiOnboardedData(entityId: string) {
      return [
        {
          key: 'MID',
          value: entityId,
        },
        {
          key: 'Parent MID',
          value:
            self?.searchEntity?.filter((entity) => entity?.identificationNumber === entityId)?.[0]?.entity
              ?.parentEntityIdentificationNumber ?? 'NA',
        },
        {
          key: 'Channel Id',
          value: self?.configurations?.filter((config) => config.key === 'OWN_CHANNEL')?.[0]?.value ?? 'NA',
        },
      ]
    },
    getVpas() {
      const getFromStatus = (status: string) => {
        const values: any = {
          'Fetched from MAS': '',
          'Added in MMS': 'Disable VPA',
          'Added in MMS (Disabled)': 'Enable VPA',
          'Deleted from MAS': '',
        }
        return values[status]
      }
      const data = self.vpas?.map((item: any, index: number) => {
        return {
          id: `${index + 1}.`,
          vpa: item?.vpa,
          mindgateId: item?.mindgateId,
          vpaStatus: item?.status,
          enableVpa: item?.disabled, // getFromStatus(item.status),
        }
      })
      return data[0]
    },
    getEmApiOnboardedData() {
      return [
        { key: 'EID', value: self.eid },
        { key: 'Entity name', value: self.entityName },
        { key: 'Channel Id', value: self.channelId },
      ]
    },
    getUpiConfig() {
      return self.upiConfig
    },
    getContactProfileValue(id: string, key: string) {
      return self.contactProfiles.map((item) => {
        if (item.id === id) {
          return item[key]
        }
      })
    },
    getCreateGroupData() {
      const groupContacts = self.contactProfiles.map((contact) => {
        return {
          // salutation: contact.salutation, // TODO:  not in UI hence commented
          mobileNumber: contact.mobileNumber ?? '',
          firstName: contact.firstName ?? '',
          lastName: contact.lastName ?? '',
          gender: contact?.gender ?? '',
          ...(contact?.phone1?.length > 0 && { phone1: contact.phone1 ?? '' }),
          role: contact.role ?? '',
          emailId: contact.emailId ?? '',
          uploadId: self.uploadId,
          groupContactNotification: {
            email: contact.allowNotification === 'EMAIL' || contact.allowNotification === 'All',
            sms: contact.allowNotification === 'SMS' || contact.allowNotification === 'All',
          },
          groupContactAddress: {
            addressType: 'COMMUNICATION_ADDR',
            addressLine1: contact.addressLine1,
            addressLine2: contact.addressLine2,
            pincode: contact.pincode,
            city: contact.city,
            state: contact.state,
            countryCode: '356',
            // latitude: 0.0, // TODO:  not in UI hence commented
            // longitude: 0.0, // TODO:  not in UI hence commented
          },
        }
      })

      let data = {
        brandName: self.businessDetail.businessBrandName ?? '',
        legalName: self.businessDetail.legalEntityName ?? '',
        type: 'GROUP',
        groupAddress: [
          {
            addressType: 'PERMANENT_ADDR',
            addressLine1: `${self.businessDetail.primaryAddress1}`,
            addressLine2: self.businessDetail.primaryAddress2 ?? '',
            addressLine3: self.businessDetail.primaryAddress2 ?? '',
            pincode: self.businessDetail.pincode,
            state: self.businessDetail.stateUt,
            city: self.businessDetail.city,
            countryCode: '356',
            // latitude: 0.0, // TODO: check value as not in UI
            // longitude: 0.0, // TODO: check value as not in UI
          },
        ],
        groupContacts: groupContacts,
      }
      return data
    },
    getSubGroupData() {
      let data = {
        brandName: self.businessDetail.businessBrandName ?? '',
        legalName: self.businessDetail.legalEntityName ?? '',
        type: 'SUBGROUP',
        groupIdentificationNumber: self?.group?.groupId ?? '',
        uploadId: self.uploadId,
      }
      return data
    },
    getEntityData(isMasMidFlow: boolean = false) {
      const programDetailsSrc = isMasMidFlow ? self.entityDetails?.programCategoryDetails : self?.programDetails
      const addrDetailsMas = self.entityDetails?.addressDetails
      const contactProfilesSrc = isMasMidFlow ? self?.entityDetails?.contactDetails : self.contactProfiles
      const businessProfileSrc = isMasMidFlow ? self?.entityDetails?.businessProfile : self?.businessDetail
      const merchantCategory = RootStore.getLovValueForDescription(
        'MerchantCategory',
        self?.businessDetail?.gstCategory,
      )
      const dealerCategory =
        merchantCategory !== 'UNREGISTERED'
          ? RootStore.getLovValueForDescription('GSTDealerCategory', self?.businessDetail?.gstDealerCategory ?? '')
          : 'NA'
      const typeOfBusiness =
        merchantCategory === 'UNREGISTERED'
          ? 'NA'
          : RootStore.getLovValueForDescription('BusinessType', self?.businessDetail?.typeOfBusiness)
      const gstDetailsSrc = isMasMidFlow
        ? {
            gstin: self.entityDetails?.gstDetails?.gstin,
            merchantCategory: self.entityDetails?.gstDetails?.merchantCategory,
            dealerCategory: self.entityDetails?.gstDetails?.dealerCategory,
            jioGST: self.entityDetails?.gstDetails?.jioGST,
            typeOfBusiness: self.entityDetails?.gstDetails?.typeOfBusiness,
          }
        : {
            gstin: self?.businessDetail?.gstNumber ?? '',
            merchantCategory: merchantCategory,
            dealerCategory: dealerCategory,
            typeOfBusiness: typeOfBusiness,
            jioGST: self?.businessDetail?.jioGstAcceptanceTs,
          }
      const programCategoryDetails = programDetailsSrc?.map((program) => {
        return {
          programId: program?.programId ?? '',
          referenceId: program?.referenceId,
        }
      })
      const addressDetails = isMasMidFlow
        ? addrDetailsMas
        : [
            {
              addressLine1:
                self?.businessDetail?.primaryAddress1?.length > 0 ? self?.businessDetail?.primaryAddress1 : null,
              addressLine2:
                self.businessDetail.primaryAddress2?.length > 0 ? self?.businessDetail?.primaryAddress2 : null,
              addressLine3:
                self.businessDetail.primaryAddress2?.length > 0 ? self?.businessDetail?.primaryAddress2 : null,
              addressType:
                self?.businessDetail?.primaryAddress1?.length > 0 ||
                self.businessDetail?.primaryAddress2?.length > 0 ||
                self.businessDetail?.pincode?.length > 0 ||
                self.businessDetail?.city?.length > 0 ||
                self.businessDetail?.stateUt?.length > 0
                  ? 'COMMUNICATION_ADDR'
                  : null,
              pincode: self.businessDetail?.pincode?.length > 0 ? self?.businessDetail?.pincode : null,
              city: self.businessDetail?.city?.length > 0 ? self?.businessDetail?.city : null,
              state: self.businessDetail?.stateUt?.length > 0 ? self?.businessDetail?.stateUt : null,
              countryCode:
                self?.businessDetail?.primaryAddress1?.length > 0 ||
                self?.businessDetail?.primaryAddress2?.length > 0 ||
                self?.businessDetail?.pincode?.length > 0 ||
                self?.businessDetail?.city?.length > 0 ||
                self?.businessDetail?.stateUt?.length > 0
                  ? '356'
                  : null,
              latitude:
                self?.businessDetail?.businessLatitude?.length > 0 ? self?.businessDetail?.businessLatitude : null,
              longitude:
                self?.businessDetail?.businessLongitude?.length > 0 ? self?.businessDetail?.businessLongitude : null,
            },
          ]
      const contactDetails = contactProfilesSrc?.map((contact) => {
        return {
          mobileNumber: contact?.mobileNumber,
          firstName: contact?.firstName,
          lastName: contact?.lastName,
          phone1: contact?.phone1,
          phone2: contact?.phone2,
          phoneExt: contact?.phoneExt,
          emailId: contact?.emailId,
          gender: contact?.gender,
          role: contact?.role,
          dateOfBirth: contact?.dateOfBirth,
          allowNotification: contact?.allowNotification,
          fax: contact?.fax,
          landlineNumber: contact?.landlineNumber,
          professionalTitle: contact?.professionalTitle,
          salutation: contact?.salutation,
          type: contact?.type,
          websiteUrl: contact?.websiteUrl,
          countryCode: contact?.countryCode,
          entityContactAddress: getEntityContactAddress(contact, isMasMidFlow),
        }
      })

      let data = {
        applicationId: `NEW-${getFormattedDate()}`,
        ...(!isMasMidFlow &&
          self.entityParentType === 'SubGroup' &&
          getSubGroupIdentificationNumber(self.selectedParentEntityId)),
        ...(isMasMidFlow &&
          self.entityParentType === 'SubGroup' && {
            subGroupIdentificationNumber:
              self.selectedParentEntityId?.length > 0 ? self.selectedParentEntityId : self.subGroupId,
          }),
        ...(isMasMidFlow &&
          self.entityParentType === 'Entity' &&
          getParentEntityIdentificationId(self.emsParentEntityIdentificationNumber)),
        ...(!isMasMidFlow &&
          self.entityParentType === 'Entity' &&
          self.emsParentEntityIdentificationNumber.length > 0 &&
          getParentEntityIdentificationId(self.emsParentEntityIdentificationNumber)),
        type: 'MERCHANT',
        legalName: isMasMidFlow ? self.entityDetails?.entity?.legalName : self?.businessDetail?.legalEntityName,
        businessName: isMasMidFlow ? self.entityDetails?.entity?.businessName : self?.businessDetail?.businessBrandName,
        ...(isMasMidFlow && { masParentId: self.entityDetails?.entity?.masParentId }),
        merchantOtpDate: isMasMidFlow
          ? self.entityDetails?.entity?.merchantOtpDate
          : self.businessDetail.merchantOtpDate,
        deviceOtpDate: isMasMidFlow ? self.entityDetails?.entity?.deviceOtpDate : self.businessDetail.deviceOtpDate,
        source: isMasMidFlow ? 'MAS' : 'EMS',
        ...(isMasMidFlow && { identificationNumber: self?.entityDetails?.entity?.identificationNumber }),
        ...(isMasMidFlow && { activatedAt: self?.entityDetails?.entity?.activatedAt }),
        ...(isMasMidFlow && { defPostingEntity: self?.entityDetails?.entity?.defPostingEntity }),
        ...(isMasMidFlow && { legalOwnerName: self?.entityDetails?.entity?.legalOwnerName }),
        ...(isMasMidFlow && { merchantLevel: self?.entityDetails?.entity?.merchantLevel }),
        ...(isMasMidFlow && { name: self?.entityDetails?.entity?.name }),
        ...(isMasMidFlow && { oldStatus: self?.entityDetails?.entity?.oldStatus }),
        ...(isMasMidFlow && { ownerType: self?.entityDetails?.entity?.ownerType }),
        ...(isMasMidFlow && { terminatedAt: self?.entityDetails?.entity?.terminatedAt }),
        ...(isMasMidFlow && { status: self?.entityDetails?.entity?.status }),
        businessProfile: {
          ownershipType: isMasMidFlow
            ? businessProfileSrc?.ownershipType
            : RootStore.getLovValueForDescription('OwnershipType', businessProfileSrc?.ownershipType ?? ''),
          businessChannel: isMasMidFlow
            ? businessProfileSrc?.businessChannel
            : RootStore.getLovValueForDescription('BusinessChannel', businessProfileSrc?.businessChannel ?? ''),
          setUpLevel: isMasMidFlow
            ? self.entityDetails?.businessProfile?.setUpLevel
            : RootStore.getLovValueForDescription('SetupLevel', self.businessDetail.setupLevel ?? ''),
          ...(isMasMidFlow && {
            premiseType: isMasMidFlow
              ? businessProfileSrc?.premiseType
              : RootStore.getLovValueForDescription('PremiseType', businessProfileSrc?.premiseType ?? ''),
          }),
          businessPan: isMasMidFlow
            ? self.entityDetails?.businessProfile?.businessPan
            : self.businessDetail.businessPAN ?? '',
          webAddress: businessProfileSrc?.webAddress,
          ...(isMasMidFlow && {
            storeType: isMasMidFlow
              ? businessProfileSrc?.storeType
              : RootStore.getLovValueForDescription('StoreType', businessProfileSrc?.storeType ?? ''),
          }),
          yearsInBusiness: isMasMidFlow
            ? self.entityDetails?.businessProfile?.yearsInBusiness
            : self.businessDetail.yearsOfBusiness ?? '',
          businessLine: businessProfileSrc?.businessLine,
          mccCode: businessProfileSrc?.mccCode,
          dailyTransactionVolume: businessProfileSrc?.dailyTransactionVolume,
          dailyTransactionValue: businessProfileSrc?.dailyTransactionValue,
          businessCategory: isMasMidFlow
            ? self.entityDetails?.businessProfile?.businessCategory
            : self.businessDetail.businessCategory ?? '',
          ...(!isMasMidFlow &&
            self.entityDetails?.businessProfile?.mccCode === '5912' && {
              pharmacistName: self.entityDetails?.businessProfile?.pharmacistName,
            }),
          ...(!isMasMidFlow &&
            self.entityDetails?.businessProfile?.mccCode === '5912' && {
              pharmacyCouncilNumber: self.entityDetails?.businessProfile?.pharmacyCouncilNumber,
            }),
          ...(isMasMidFlow && {
            agentId: self.entityDetails?.businessProfile?.agentId,
            marketPlace: self.entityDetails?.businessProfile?.marketPlace,
            merchIrctcFlag: self.entityDetails?.businessProfile?.merchIrctcFlag,
            pharmacistName: self.entityDetails?.businessProfile?.pharmacistName,
            pharmacyCouncilNumber: self.entityDetails?.businessProfile?.pharmacyCouncilNumber,
            annualRevenueSegment: self?.entityDetails?.businessProfile?.annualRevenueSegment,
          }),
        },
        gstDetails: gstDetailsSrc,
        addressDetails: addressDetails,
        contactDetails: contactDetails,
        ...(isMasMidFlow && { deviceDetails: self?.devices?.length > 0 ? self?.devices : [] }),
        ...(isMasMidFlow && { settlementDetails: self?.entityDetails?.settlementDetails }),
        feePackageDetails: isMasMidFlow
          ? self?.entityDetails?.feePackageDetails
          : {
              feePkgId: self.businessDetail.mdrPackageId ?? '',
              inheritParentFeePackage: self.businessDetail.inheritParentFeePackage === 'Yes',
              feePackageName: self.businessDetail.mdrPackageDetails,
            },
        programCategoryDetails: programCategoryDetails,
        ...(isMasMidFlow && { terminalDetails: self?.entityDetails?.terminalDetails }),
        ...(isMasMidFlow && { riskSettings: self?.entityDetails?.riskSettings }),
        ...(isMasMidFlow && { kycDetailDetails: self?.entityDetails?.kycDetails }),
        ...(isMasMidFlow && { unusedMASConfigResponse: self?.entityDetails?.unusedMASConfigResponse }),
        ...(isMasMidFlow && { authorisedSignatoryDetails: self?.entityDetails?.authorisedSignatoryDetails }),
        ...(isMasMidFlow && { notifyDetails: self?.entityDetails?.notifyDetails }),
        uploadId: self.uploadId,
      }
      console.log('payload data', data)
      return data
    },
    getDevicesList(entityId: string, type: string) {
      if (entityId === '' && type !== 'createSingleEntity') {
        return self.devices.map((device) => {
          return {
            // tid: device?.id,
            dsn: device?.deviceSerialNo,
            status: RootStore.getLovsDescriptionFromKeyValue('DeviceStatus', device?.deviceStatus),
            // unlink: device?.status === 'TID_ALLOTED' ? 'Unlink' : 'Link',
          }
        })
      } else if (self.entityDetails && type === 'createSingleEntity') {
        return self.devices.map((device) => {
          return {
            // tid: device?.id,
            dsn: device?.deviceSerialNo,
            status: RootStore.getLovsDescriptionFromKeyValue('DeviceStatus', device?.deviceStatus),
            // unlink: device?.status === 'TID_ALLOTED' ? 'Unlink' : 'Link',
          }
        })
      }
    },
    updateDevicePostLinkUnlink(id: string, updatedData: any) {
      return self.devices.map((device) => {
        if (device.id === id) {
          return {
            ...device,
            status: updatedData?.deviceStatus,
            unlink: updatedData?.status === 'TID_ALLOTED' ? 'Unlink' : 'Link',
          }
        } else {
          return device
        }
      })
    },
    getGstList() {
      return self.upiConfig.gstConfig.gstNumbers
    },
    getAllEmisByType(type: string) {
      let allEmis: any[] = []
      self.emis.map((emi) => {
        if (emi.type === type) {
          emi.banks.map((bank) => {
            bank.tenuresInterest.map((tenureInt) => {
              const emiBank = {
                checkBox: tenureInt.isSelected,
                col2: bank.name,
                col3: tenureInt.tenure,
                col4: tenureInt.interest,
              }
              allEmis.push(emiBank)
            })
          })
        }
      })
      console.log('===> getAllEmisByType')
      if (self.emiBankSelected !== 'All' && self.emiBankSelected.length > 0) {
        return allEmis.filter((emi) => emi.col2 === self.emiBankSelected)
      } else if (self.emiTenureSelected !== 'All' && self.emiTenureSelected.length > 0) {
        return allEmis.filter((emi) => emi.col3 === self.emiTenureSelected)
      } else if (self.emiBankSelected === 'All' && self.emiTenureSelected === 'All') {
        return allEmis
      } else if (self.emiBankSelected.length > 0 && self.emiTenureSelected.length > 0) {
        return allEmis.filter((emi) => emi.col3 === self.emiTenureSelected && emi.col2 === self.emiBankSelected)
      } else {
        return allEmis
      }
    },
    getEmiBanksFromType(type: string) {
      let banks: any[] = [{ id: 0, value: 'All' }]
      self.emis.map((emi) => {
        if (emi.type === type) {
          emi.banks.map((bank) => {
            const bankData = {
              id: bank.id,
              value: bank.name,
            }
            banks.push(bankData)
          })
        }
      })
      return banks
    },
    getAllTenuresFromType(type: string) {
      let tenures: any[] = [{ id: 0, value: 'All' }]
      self.emis.map((emi) => {
        if (emi.type === type) {
          emi.banks.map((bank) => {
            bank.tenuresInterest.map((tenuresInterest, index) => {
              const tenureData = {
                id: index + 1,
                value: tenuresInterest.tenure,
              }
              tenures.push(tenureData)
            })
          })
        }
      })
      tenures = tenures.filter((tenure, index, self) => index === self.findIndex((t) => t.value === tenure.value))
      return tenures
    },
    getEmisFromSelectedBank(type: string, bankName: string) {
      let emisSelected: any[] = []
      if (bankName !== 'All') {
        self.emis.map((emi) => {
          if (emi.type === type) {
            emi.banks.map((bank) => {
              if (bank.name === bankName) {
                bank.tenuresInterest.map((tenuresInterest) => {
                  const emiBank = {
                    checkBox: tenuresInterest.isSelected,
                    col2: bank.name,
                    col3: tenuresInterest.tenure,
                    col4: tenuresInterest.interest,
                  }
                  emisSelected.push(emiBank)
                })
              }
            })
          }
        })
        console.log('==> getEmisFromSelectedBank')
        return self.emiTenureSelected.length === 0 || self.emiTenureSelected === 'All'
          ? emisSelected
          : emisSelected.filter((emi) => emi.col3 === self.emiTenureSelected)
      } else {
        console.log('==> getEmisFromSelectedBank')
        return (self as any).getAllEmisByType(type)
      }
    },
    getEmisFromSelectedTenure(type: string, tenureSelected: string) {
      let emisSelected: any[] = []
      if (tenureSelected !== 'All') {
        self.emis.map((emi) => {
          if (emi.type === type) {
            emi.banks.map((bank) => {
              bank.tenuresInterest.map((tenuresInterest) => {
                if (tenuresInterest.tenure === tenureSelected) {
                  const emiBank = {
                    checkBox: tenuresInterest.isSelected,
                    col2: bank.name,
                    col3: tenuresInterest.tenure,
                    col4: tenuresInterest.interest,
                  }
                  emisSelected.push(emiBank)
                }
              })
            })
          }
        })
        console.log('===> getEmisFromSelectedTenure')
        return self.emiBankSelected.length === 0 || self.emiBankSelected === 'All'
          ? emisSelected
          : emisSelected.filter((emi) => emi.col2 === self.emiBankSelected)
      } else {
        console.log('===> getEmisFromSelectedTenure else')
        return (self as any).getAllEmisByType(type)
      }
    },
    getGeneralConfigData() {
      const data: any = {
        mid: self?.mid ?? '',
        parentMid: self?.parentMid ?? '',
        channelId: self?.channelId ?? '',
        merchantName: self?.merchantName ?? '',
        vpa: self?.vpas[0]?.vpa ?? '',
        qrUrl: self?.qrUrl ?? '',
        s2sUrl: self?.s2sUrl ?? '',
        INTEGRATION_TYPE: self?.integrationType ?? '',
        sodexo: self?.sodexo ?? '',
        offers: self?.offers ?? '',
        emiFlag: self?.emiFlag ?? '',
        subscriptions: self?.subscriptions ?? '',
        tokenizationFlag: self?.tokenizationFlag ?? '',
        collectLink: self?.collectLink ?? '',
        convienienceFee: self?.convienienceFee ?? '',
        MAC_KEY: self?.MAC_KEY ?? '',
        AES_KEY: self?.AES_KEY ?? '',
        CONVENIENCE_MODEL: self?.CONVENIENCE_MODEL ?? '',
        REFUND_TYPE: self?.REFUND_TYPE ?? '',
        GST_INVOICE_TEMPLATE: self?.GST_INVOICE_TEMPLATE ?? '',
      }
      const genConfig = Object.keys(data).map((config) => {
        return {
          key: config,
          value: data[config],
        }
      })
      return genConfig
    },
    getPaymentConfigdata() {
      return {
        paymentConfig: self.paymentConfig,
        paymentChoices: self.merchant.preferences,
        emis: self.emis,
      }
    },
    getCardsList(cardType: string) {
      const cards: any[] = []
      console.log('===> getCardsList self.cardList', JSON.parse(JSON.stringify(self.cardList)))
      self.cardList.map((card) => {
        if (card.type === cardType) {
          const { isDomesticAllowed, isInternationalAllowed, isPremium } = getIsCheckedFromCardSearchConfig(
            card,
            self.cardSelectedList,
          )
          let data = {
            type: card.type,
            scheme: card.scheme,
            name: CardSchema[card.scheme] ?? '',
            Domestic: isDomesticAllowed,
            International: isInternationalAllowed,
            Platinum: isPremium,
          }
          // console.log('===> getCardsList  cards.push(data)', JSON.parse(JSON.stringify(data)))
          cards.push(data)
        }
      })
      console.log('===> getCardsList cards', JSON.parse(JSON.stringify(cards)))
      if (cards.length > 0) {
        const newCardsArr = cards.map((card) => {
          let abc = {}
          newHeaderMap.map((item) => {
            if (item !== '') {
              let newObj = {
                [item]:
                  item === 'Domestic'
                    ? card.Domestic
                    : item === 'International'
                    ? card.International
                    : item === 'Platinum'
                    ? card.Platinum
                    : false,
              }
              abc = { ...abc, ...newObj }
            }
          })
          return { ...card, ...abc }
        })
        return newCardsArr
      } else {
        return []
      }
    },
    getUpdatedCardsList(selectedType: string) {
      const cards: any[] = []
      self.cardList
        .filter((data) => data.type === selectedType)
        .map((card) => {
          if (card.isDomesticAllowed || card.isInternationalAllowed || card.isPremium) {
            let data = {
              type: card.type,
              scheme: card.scheme,
              name: CardSchema[card.scheme] ?? '',
              Domestic: card.isDomesticAllowed,
              International: card.isInternationalAllowed,
              Platinum: card.isPremium,
            }
            cards.push(data)
          } else {
            let data = {
              type: card.type,
              scheme: card.scheme,
              name: CardSchema[card.scheme] ?? '',
              Domestic: card.isDomesticAllowed,
              International: card.isInternationalAllowed,
              Platinum: card.isPremium,
            }
            cards.push(data)
          }
        })
      console.log('===> getUpdatedCardsList cards', JSON.parse(JSON.stringify(cards)))
      if (cards.length > 0) {
        const newCardsArr = cards.map((card) => {
          let abc = {}
          newHeaderMap.map((item) => {
            if (item !== '') {
              let newObj = {
                [item]:
                  item === 'Domestic'
                    ? card.Domestic
                    : item === 'International'
                    ? card.International
                    : item === 'Platinum'
                    ? card.Platinum
                    : false,
              }
              abc = { ...abc, ...newObj }
            }
          })
          return { ...card, ...abc }
        })
        return newCardsArr
      } else {
        return []
      }
    },
    getPaymentConfigRequestData() {
      let bankList: any = []
      let payLaterList: any = []
      let walletList: any = []
      let defaultList: any = []
      self.merchant.preferences.bankList.map((bank) => {
        if (+bank.type === PAYMENT_MODE_SUBTYPES.NB && bank.isSelected) {
          console.log('===> bank: ', bank)
          bankList.push({ key: 'SUPPORTED_NETBANKING', value: bank.id })
        }
      })
      self.merchant.preferences.payLaterList.map((payLater) => {
        if (+payLater.type === PAYMENT_MODE_SUBTYPES.PAYLATER && payLater.isSelected) {
          console.log('===> payLater: ', payLater)
          payLaterList.push({ key: 'SUPPORTED_PAYLATER', value: payLater.id })
        }
      })
      self.merchant.preferences.walletList.map((wallet) => {
        if (+wallet.type === PAYMENT_MODE_SUBTYPES.WALLET && wallet.isSelected) {
          console.log('===> wallet: ', wallet)
          walletList.push({ key: 'SUPPORTED_WALLET', value: wallet.id })
        }
      })
      const data: any = {
        ALLOW_DUPLICATES: self.upiConfig.isDuplicateTxnAllowed ? 'Y' : 'N',
        RANDOM_QR: self.upiConfig.isRandomTxnAllowed ? 'Y' : 'N',
      }
      const payConfig = Object.keys(data).map((config) => {
        return {
          key: config,
          value: data[config],
        }
      })
      //TODO: check if need condition from ui selection to push
      defaultList.push({ key: 'ALLOWED_TXN_TYPE', value: 110 })
      defaultList.push({ key: 'ALLOWED_TXN_TYPE', value: 212 })
      defaultList.push({ key: 'ALLOWED_TXN_TYPE', value: 211 })
      defaultList.push({ key: 'ALLOWED_TXN_TYPE', value: 310 })
      defaultList.push({ key: 'ALLOWED_TXN_TYPE', value: 306 })
      defaultList.push({ key: 'ALLOWED_TXN_TYPE', value: 471 })
      defaultList.push({ key: 'ALLOWED_TXN_TYPE', value: 114 })
      defaultList.push({ key: 'ALLOWED_TXN_TYPE', value: 472 })

      defaultList.push({ key: 'ALLOWED_CHANNEL', value: 120621459436 })
      defaultList.push({ key: 'ALLOWED_CHANNEL', value: 9081 })
      defaultList.push({ key: 'ALLOWED_CHANNEL', value: 6162 })
      defaultList.push({ key: 'ALLOWED_CHANNEL', value: 6163 })
      defaultList.push({ key: 'ALLOWED_CHANNEL', value: 8008 })
      defaultList.push({ key: 'ALLOWED_CHANNEL', value: 2103 })

      defaultList.push({ key: 'INVOICE_REGEX_PATTERN', value: '[0-9]{2}A1[0-9]{12}' })
      defaultList.push({ key: 'INVOICE_REGEX_PATTERN', value: '([0-9]{17}[A-Z]{1,2}-[0-9][0-9])|([0-9]{20}[A-Z])' })
      defaultList.push({ key: 'INVOICE_REGEX_PATTERN', value: '[0-9]{17}[A-Z]{1,2}-[0-9][0-9]$' })

      defaultList.push({ key: 'PAYMENT_ACCEPTANCE', value: 613 })
      defaultList.push({ key: 'RANDOM_QR', value: 'Y' })

      return [...payConfig, ...bankList, ...walletList, ...payLaterList, ...defaultList]
    },
    getMetaConfigListRequestData() {
      let defaultList: any = []
      defaultList.push({ key: 'ALLOWED_CHANNEL', value: 120621459436 })
      defaultList.push({ key: 'ALLOWED_CHANNEL', value: 9081 })
      defaultList.push({ key: 'ALLOWED_CHANNEL', value: 6162 })
      defaultList.push({ key: 'ALLOWED_CHANNEL', value: 6163 })
      defaultList.push({ key: 'ALLOWED_CHANNEL', value: 8008 })
      defaultList.push({ key: 'ALLOWED_CHANNEL', value: 2103 })

      defaultList.push({ key: 'INVOICE_REGEX_PATTERN', value: '[0-9]{2}A1[0-9]{12}' })
      defaultList.push({ key: 'INVOICE_REGEX_PATTERN', value: '([0-9]{17}[A-Z]{1,2}-[0-9][0-9])|([0-9]{20}[A-Z])' })
      defaultList.push({ key: 'INVOICE_REGEX_PATTERN', value: '[0-9]{17}[A-Z]{1,2}-[0-9][0-9]$' })

      if (self.channelIds.length > 0) {
        self.channelIds.map((channelId) => {
          const data = { key: 'ALLOWED_CHANNEL', value: channelId.id }
          defaultList.push(data)
        })
      }
      return defaultList
    },
    getDefaultConfigsToInsert() {
      const configs = [
        {
          configType: 'ALLOWED_TXN_TYPE',
          configValues: [
            {
              status: 'ACTIVE',
              key: '114',
              value: 'Y',
            },
          ],
        },
        {
          configType: 'ALLOWED_TXN_TYPE',
          configValues: [
            {
              status: 'ACTIVE',
              key: '110', //Allowed Purchase Transaction for PG UI
              value: 'Y',
            },
          ],
        },
        self.emiFlag === 'Yes' && {
          configType: 'ALLOWED_TXN_TYPE',
          configValues: [
            {
              status: 'ACTIVE',
              key: '114', //Allowed EMI Transaction for PG UI
              value: 'Y',
            },
          ],
        },
        self.s2sUrl.length > 0 && {
          configType: 'CALLBACK_URL',
          configValues: [
            {
              status: 'ACTIVE',
              key: 'S2S_URL',
              value: self.s2sUrl,
            },
          ],
        },
        self.subscriptions === 'Yes' && {
          configType: 'PAYMENT_ACCEPTANCE',
          configValues: [
            {
              status: 'ACTIVE',
              key: '576', //subscriptions
              value: 'Y',
            },
          ],
        },
        self.subscriptions === 'Yes' && {
          configType: 'PAYMENT_ACCEPTANCE',
          configValues: [
            {
              status: 'ACTIVE',
              key: '590', //CCSI subsriptions
              value: 'Y',
            },
          ],
        },
        self.emiFlag === 'Yes' && {
          configType: 'PAYMENT_ACCEPTANCE',
          configValues: [
            {
              status: 'ACTIVE',
              key: '600', //CARDLESS EMI
              value: 'Y',
            },
          ],
        },
        {
          configType: 'INTEGRATION_TYPE',
          configValues: [
            {
              status: 'ACTIVE',
              key: 'PCI',
              value: self.integrationType === 'PCI' ? 'Y' : 'N',
            },
          ],
        },
        self.sodexo === 'Yes' && {
          configType: 'PAYMENT_ACCEPTANCE',
          configValues: [
            {
              status: 'ACTIVE',
              key: '613', //FOOD_CARD
              value: 'Y',
            },
          ],
        },
        self.collectLink === 'Yes' && {
          configType: 'PAYMENT_ACCEPTANCE',
          configValues: [
            {
              status: 'ACTIVE',
              key: '595', //COLLECT_LINK_REQUEST
              value: 'Y',
            },
          ],
        },
        self.offers === 'Yes' && {
          configType: 'OFFER_APPLICABLE',
          configValues: [
            {
              status: 'ACTIVE',
              key: 'MERCHANT_OFFER', //Offer
              value: 'Y',
            },
          ],
        },
        self.convienienceFee !== '' && {
          configType: 'MERCHANT_CONVENIENCE_FEE',
          configValues: [
            {
              status: 'ACTIVE',
              key: 'CONVENIENCE_FEE', //CONVENIENCE_FEE
              value: self.convienienceFee === 'Yes' ? '1' : '0',
            },
          ],
        },
        self.CONVENIENCE_MODEL !== '' && {
          configType: 'MERCHANT_CONVENIENCE_FEE',
          configValues: [
            {
              status: 'ACTIVE',
              key: 'CONVENIENCE_MODEL',
              value: self.CONVENIENCE_MODEL === 'Yes' ? '1' : '0',
            },
          ],
        },
        self.REFUND_TYPE !== '' && {
          configType: 'MERCHANT_CONVENIENCE_FEE',
          configValues: [
            {
              status: 'ACTIVE',
              key: 'REFUND_TYPE',
              value: self.REFUND_TYPE === 'Yes' ? '1' : '0',
            },
          ],
        },
        self.GST_INVOICE_TEMPLATE !== '' && {
          configType: 'MERCHANT_CONVENIENCE_FEE',
          configValues: [
            {
              status: 'ACTIVE',
              key: 'GST_INVOICE_TEMPLATE',
              value: self.GST_INVOICE_TEMPLATE,
            },
          ],
        },
        {
          configType: 'ALLOWED_RETRIES',
          configValues: [
            {
              status: 'ACTIVE',
              key: 'RETRY_COUNT',
              value: '4',
            },
          ],
        },
        {
          configType: 'KEYS',
          configValues: [
            {
              status: 'ACTIVE',
              key: 'MAC_KEY',
              value: '+xIw8/HwjgqDMcSulLJwE4d+xwx4TxUpJ55ek1Foff7NaT31uzhuMhCuic7+eivB',
            },
          ],
        },
        {
          configType: 'KEYS',
          configValues: [
            {
              status: 'ACTIVE',
              key: 'AES_KEY',
              value: 'firoBFK0cQxjIigvFK2KsAi3mmPbMjfbzJR+rbtaMro3ePcWE/Rjn3Hqw7GaSvbk',
            },
          ],
        },
        {
          configType: 'SAVE_CARD',
          configValues: [
            {
              status: 'ACTIVE',
              key: 'GLOBAL',
              value: 'Y',
            },
          ],
        },
        {
          configType: 'SAVE_CARD',
          configValues: [
            {
              status: 'ACTIVE',
              key: 'LOCAL',
              value: 'Y',
            },
          ],
        },
        {
          configType: 'SAVE_CARD',
          configValues: [
            {
              status: 'ACTIVE',
              key: 'AES_KEY',
              value: 'firoBFK0cQxjIigvFK2KsAi3mmPbMjfbzJR+rbtaMro3ePcWE/Rjn3Hqw7GaSvbk',
            },
          ],
        },
        {
          configType: 'TIMEOUT',
          configValues: [
            {
              status: 'ACTIVE',
              key: 'CLOSE_TIME',
              value: '2000',
            },
          ],
        },
        {
          configType: 'TIMEOUT',
          configValues: [
            {
              status: 'ACTIVE',
              key: '300',
              value: '1200',
            },
          ],
        },
        {
          configType: 'CALLBACK_URL',
          configValues: [
            {
              status: 'ACTIVE',
              key: '212',
              value: 'https://scm-uat.ril.com/v1/rpsl/transaction',
            },
          ],
        },
      ]
      const s2sUrls = getUrlConfigs(self.s2sUrls, 'CALLBACK_URL')
      const collectLinks = getUrlConfigs(self.collectLinkUrls, 'COLLECT_LINK_INFO')
      return [configs, s2sUrls, collectLinks]
    },
    getAddedUrls(type: string) {
      if (type === 's2sUrls') {
        return self.s2sUrls
      } else if (type === 'collectLinkUrls') {
        return self.collectLinkUrls
      }
    },
    getUrlsFromType(type: string, isEdit: boolean) {
      if (type === 's2sUrls') {
        let s2sUrlslist = []
        if (self.configurations && self.configurations.length > 0) {
          self.configurations.map((config) => {
            if (config.configType === 'CALLBACK_URL') {
              s2sUrlslist.push({
                type: config.key,
                url: config.value,
                ...(isEdit && { deleteOnly: 'deleteOnly' }),
              })
            }
          })
        }
        return s2sUrlslist
      } else if (type === 'collectLinkUrls') {
        let collectLinkList = []
        if (self.configurations && self.configurations.length > 0) {
          self.configurations.map((config) => {
            if (config.configType === 'COLLECT_LINK_INFO') {
              collectLinkList.push({
                type: config.key,
                url: config.value,
                ...(isEdit && { deleteOnly: 'deleteOnly' }),
              })
            }
          })
        }
        return collectLinkList
      }
    },
    getChannelIds() {
      return self.channelIds
    },
    getTableChannelIds() {
      let channelList: any = []
      self.channelIds.map((channelId) => {
        channelList.push({
          id: channelId?.value,
          deleteOnly: 'deleteOnly',
        })
      })
      return channelList
    },
    isConvenienceFeeEnabled() {
      return self.convienienceFee === 'Yes'
    },
    getTerminals() {
      return self.merchant.terminals.map((terminal) => {
        return {
          terminalID: terminal.terminalID,
          vpaQrUrl: `${terminal.businessVPA},${terminal.qrUrl}`,
        }
      })
    },
    isS2STypeAdded(type: string) {
      let isAdded = false
      for (let i = 0; i < self.s2sUrls.length; i++) {
        if (self.s2sUrls[i].type === type) {
          isAdded = true
          break
        }
      }
      return isAdded
    },
    isCollectLinkTypeAdded(type: string) {
      let isAdded = false
      for (let i = 0; i < self.collectLinkUrls.length; i++) {
        if (self.collectLinkUrls[i].type === type) {
          isAdded = true
          break
        }
      }
      return isAdded
    },
    isChannelIdAdded(id: string) {
      let isAdded = false
      for (let i = 0; i < self.channelIds.length; i++) {
        if (self.channelIds[i].value === id) {
          isAdded = true
          break
        }
      }
      return isAdded
    },
    getQrUrlOfTerminal(terminalId: string) {
      let qrUrl = ''
      for (let i = 0; i < self.merchant.terminals.length; i++) {
        if (self.merchant.terminals[i].terminalID === terminalId) {
          qrUrl = self.merchant.terminals[i].qrUrl
          break
        }
      }
      return qrUrl
    },
    getVpasToFetchUrls() {
      return self.merchant.terminals.map((terminal) => terminal.businessVPA)
    },
    getMasProgramDetails() {
      const list: any[] = []
      if (self?.entityDetails?.programCategoryDetails?.length > 0) {
        self.entityDetails.programCategoryDetails.map((program) => {
          list.push({
            programCategory: program?.programId ?? 'NA',
            referenceId: program?.referenceId,
          })
        })
      }
      return list
    },
    getProgramDetailsList() {
      const list: any[] = []
      self.programDetails.map((program) => {
        list.push({
          programCategory: program?.category?.length > 0 ? program?.category : program?.programId,
          referenceId: program?.referenceId?.length > 0 ? program?.referenceId : '-',
          // deleteOnly: 'deleteOnly',
        })
      })
      return list
    },
    getProgramCategoryFromProgramId(programId: string) {
      let progCategory = 'NA'
      if (programId?.length > 0) {
        for (let i = 0; i < self.programDetails.length; i++) {
          if (self.programDetails[i].programId === programId) {
            progCategory = self.programDetails[i]?.pname ?? '-'
            break
          }
        }
      }
      return progCategory
    },
    getProgramDetailsListByEntityId(entityId: string, isEditMode: boolean) {
      let list: any[] = []
      let programDetails: any[] = []
      self.searchEntity.map((data) => {
        if (data?.entity?.identificationNumber === entityId) {
          programDetails = data?.entity?.programCategoryDetails
        }
      })
      programDetails?.map((program) => {
        list.push({
          programCategory: (self as any).getProgramCategoryFromProgramId(program?.programId),
          referenceId: program?.referenceId ?? 'NA',
          // ...(isEditMode && { deleteOnly: 'deleteOnly' }),
        })
      })
      return list
    },
    getProgramDetailsListFromCreationFlow() {
      let list: any[] = []
      if (self.entityDetails.programCategoryDetails?.length > 0) {
        self.entityDetails.programCategoryDetails?.map((program) => {
          list.push({
            programCategory: (self as any).getProgramCategoryFromProgramId(program?.programId),
            referenceId: program?.referenceId ?? 'NA',
          })
        })
      }
      return list
    },
    getGroupsList() {
      const list: any[] = []
      self.groups.map((group) => {
        list.push({ groupId: group?.identificationNumber, brandName: group?.brandName ?? group?.legalName })
      })
      return list
    },
    getTidList(entityId: string, type: string) {
      const list: any[] = []
      if (entityId && self.searchEntity.length > 0 && type !== 'createSingleEntity') {
        self.searchEntity.map((data) => {
          if (data?.entity?.identificationNumber === entityId) {
            data?.terminalDetails?.map((tid: any) => {
              list.push({
                tid: tid.terminalId,
                dsn: tid?.device?.deviceSerialNo ?? 'NA',
                status: RootStore.getLovsDescriptionFromKeyValue('TerminalStatus', tid.status),
              })
            })
          }
        })
      } else if (self.entityDetails && type === 'createSingleEntity') {
        self.entityDetails.terminalDetails.map((tid: any) => {
          list.push({
            tid: tid.terminalId,
            dsn: tid?.device?.deviceSerialNo ?? 'NA',
            status: RootStore.getLovsDescriptionFromKeyValue('TerminalStatus', tid.status),
          })
        })
      }
      return list
    },
    getMakerCheckerTidList(data: any) {
      const list: any[] = []
      data?.terminalDetails?.map((tid: any) => {
        list.push({
          tid: tid.terminalId,
          dsn: tid?.device?.deviceSerialNo ?? 'NA',
          status: RootStore.getLovsDescriptionFromKeyValue('TerminalStatus', tid.status),
        })
      })
      return list
    },
    getTidVpaList(entityId: string, type: string) {
      const list: any[] = []
      if (entityId && self.searchEntity.length > 0 && type !== 'createSingleEntity') {
        self.searchEntity.map((data) => {
          if (data?.entity?.identificationNumber === entityId) {
            data?.terminalDetails?.map((tid: any) => {
              list.push({
                tid: tid.terminalId,
                vpaQrUrl: getVpaQrUrl(tid),
              })
            })
          }
        })
      } else if (self.entityDetails && type === 'createSingleEntity') {
        self.entityDetails.terminalDetails.map((tid: any) => {
          list.push({
            tid: tid.terminalId,
            vpaQrUrl: getVpaQrUrl(tid),
          })
        })
      }
      return list
    },
    getTidDetails(entityId: string, tid: string, type: string, from: string) {
      let terminalDetails = {}
      if (self.searchEntity.length > 0 && type !== EmType.createSingleEntity && type !== EmType.applicationQueue) {
        self.searchEntity.map((data) => {
          if (data?.entity?.identificationNumber === entityId) {
            data?.terminalDetails?.map((terminal: any) => {
              if (terminal.terminalId === tid) {
                terminalDetails = {
                  mid: entityId,
                  terminalId: terminal.terminalId,
                  terminalType: terminal.terminalType,
                  mobileNumber: terminal.mobileNumber,
                  nickName: terminal.nickName,
                  issueRefund: getDescriptionLov(terminal.terminalConfigurationDetails, 'ISSUE_REFUND'),
                  acceptPayment: getDescriptionLov(terminal.terminalConfigurationDetails, 'ACCEPT_PAYMENTS'),
                  sodexoFlag: getDescriptionLov(terminal.terminalConfigurationDetails, 'ACCEPT_SODEXO'),
                  cashNCarry: getDescriptionLov(terminal.terminalConfigurationDetails, 'CASH_AND_CARRY'),
                  vpa: Array.isArray(terminal?.vpaLinkings)
                    ? terminal?.vpaLinkings?.reduce((acc, item, index) => {
                        return index === 0 ? item.handle : `${acc}, ${item.handle}`
                      }, undefined) ?? 'Not Available'
                    : terminal?.vpaLinkings?.handle ?? 'Not Available',
                  status: RootStore.getLovsDescriptionFromKeyValue('TerminalStatus', terminal.status),
                }
              }
            })
          }
        })
      } else if (self?.entityDetails?.terminalDetails?.length > 0 && type === EmType.createSingleEntity) {
        self?.entityDetails?.terminalDetails?.map((terminal: any) => {
          if (terminal.terminalId === tid) {
            terminalDetails = {
              mid: terminal?.mid,
              terminalId: terminal?.terminalId,
              terminalType: terminal?.terminalType,
              mobileNumber: terminal?.mobileNumber,
              nickName: terminal?.nickName,
              issueRefund: getDescriptionLov(terminal.terminalConfigurationDetails, 'ISSUE_REFUND'),
              acceptPayment: getDescriptionLov(terminal.terminalConfigurationDetails, 'ACCEPT_PAYMENTS'),
              sodexoFlag: getDescriptionLov(terminal.terminalConfigurationDetails, 'ACCEPT_SODEXO'),
              cashNCarry: getDescriptionLov(terminal.terminalConfigurationDetails, 'CASH_AND_CARRY'),
              vpa: Array.isArray(terminal?.vpaLinkings)
                ? terminal?.vpaLinkings?.[0]?.handle ?? 'Not Available'
                : terminal?.vpaLinkings?.handle ?? 'Not Available',
              status: RootStore.getLovsDescriptionFromKeyValue('TerminalStatus', terminal.status),
            }
          }
        })
      } else if (type === EmType.applicationQueue && from?.length > 0) {
        if (from === 'CHECKER_QUEUE') {
          RootStore.globalCheckerList.map((entity) => {
            if (entity.identificationNumber === entityId) {
              entity?.terminalDetails?.map((terminal: any) => {
                if (terminal.terminalId === tid) {
                  terminalDetails = {
                    mid: entityId,
                    terminalId: terminal?.terminalId,
                    terminalType: terminal?.terminalType,
                    mobileNumber: terminal?.mobileNumber,
                    nickName: terminal?.nickName,
                    issueRefund: getDescriptionLov(terminal.terminalConfigurationDetails, 'ISSUE_REFUND'),
                    acceptPayment: getDescriptionLov(terminal.terminalConfigurationDetails, 'ACCEPT_PAYMENTS'),
                    sodexoFlag: getDescriptionLov(terminal.terminalConfigurationDetails, 'ACCEPT_SODEXO'),
                    cashNCarry: getDescriptionLov(terminal.terminalConfigurationDetails, 'CASH_AND_CARRY'),
                    vpa: Array.isArray(terminal?.vpaLinkings)
                      ? terminal?.vpaLinkings?.[0]?.handle ?? 'Not Available'
                      : terminal?.vpaLinkings?.handle ?? 'Not Available',
                    status: RootStore.getLovsDescriptionFromKeyValue('TerminalStatus', terminal.status),
                  }
                }
              })
            }
          })
        } else if (from === 'CHECKER_MYQUEUE') {
          RootStore.myCheckerList.map((entity) => {
            if (entity.identificationNumber === entityId) {
              entity?.terminalDetails?.map((terminal: any) => {
                if (terminal.terminalId === tid) {
                  terminalDetails = {
                    mid: entityId,
                    terminalId: terminal?.terminalId,
                    terminalType: terminal?.terminalType,
                    mobileNumber: terminal?.mobileNumber,
                    nickName: terminal?.nickName,
                    issueRefund: getDescriptionLov(terminal.terminalConfigurationDetails, 'ISSUE_REFUND'),
                    acceptPayment: getDescriptionLov(terminal.terminalConfigurationDetails, 'ACCEPT_PAYMENTS'),
                    sodexoFlag: getDescriptionLov(terminal.terminalConfigurationDetails, 'ACCEPT_SODEXO'),
                    cashNCarry: getDescriptionLov(terminal.terminalConfigurationDetails, 'CASH_AND_CARRY'),
                    vpa: Array.isArray(terminal?.vpaLinkings)
                      ? terminal?.vpaLinkings?.[0]?.handle ?? 'Not Available'
                      : terminal?.vpaLinkings?.handle ?? 'Not Available',
                    status: RootStore.getLovsDescriptionFromKeyValue('TerminalStatus', terminal.status),
                  }
                }
              })
            }
          })
        } else if (from === 'MAKER_QUEUE') {
          RootStore.makerList.map((entity) => {
            if (entity.identificationNumber === entityId) {
              entity?.terminalDetails?.map((terminal: any) => {
                if (terminal.terminalId === tid) {
                  terminalDetails = {
                    mid: entityId,
                    terminalId: terminal?.terminalId,
                    terminalType: terminal?.terminalType,
                    mobileNumber: terminal?.mobileNumber,
                    nickName: terminal?.nickName,
                    issueRefund: getDescriptionLov(terminal.terminalConfigurationDetails, 'ISSUE_REFUND'),
                    acceptPayment: getDescriptionLov(terminal.terminalConfigurationDetails, 'ACCEPT_PAYMENTS'),
                    sodexoFlag: getDescriptionLov(terminal.terminalConfigurationDetails, 'ACCEPT_SODEXO'),
                    cashNCarry: getDescriptionLov(terminal.terminalConfigurationDetails, 'CASH_AND_CARRY'),
                    vpa: Array.isArray(terminal?.vpaLinkings)
                      ? terminal?.vpaLinkings?.[0]?.handle ?? 'Not Available'
                      : terminal?.vpaLinkings?.handle ?? 'Not Available',
                    status: RootStore.getLovsDescriptionFromKeyValue('TerminalStatus', terminal.status),
                  }
                }
              })
            }
          })
        }
      }
      return terminalDetails
    },
    isEntityPresentInMas(entityId: string) {
      let isPresentInMas = false
      self.searchEntity.map((data) => {
        if (data?.entity?.identificationNumber === entityId) {
          isPresentInMas = data?.entity?.source === 'MAS'
        }
      })
      return isPresentInMas
    },
    getUpdatedBusinessDetails(existingBusinessDetail: any, entityId: string, type: string) {
      let dealerCategory = RootStore.getLovValueForDescription(
        'GSTDealerCategory',
        self?.businessDetail?.gstDealerCategory ?? '',
      )
      let merchantCategory = RootStore.getLovValueForDescription('MerchantCategory', self?.businessDetail?.gstCategory)
      let typeOfBusiness = RootStore.getLovValueForDescription('BusinessType', self?.businessDetail?.typeOfBusiness)
      dealerCategory = dealerCategory ? dealerCategory : undefined
      merchantCategory = merchantCategory ? merchantCategory : undefined
      typeOfBusiness = typeOfBusiness ? typeOfBusiness : undefined

      const updatedBizzDetails = {
        //businessProfile starts
        businessProfile: {
          ...{
            ownershipType: RootStore.getLovValueForDescription(
              'OwnershipType',
              self.businessDetail?.ownershipType ?? '',
            ),
          },
          id: getBusinessProfileId(entityId, self.searchEntity),
          businessChannel: RootStore.getLovValueForDescription(
            'BusinessChannel',
            self.businessDetail?.businessChannel ?? '',
          ),
          setUpLevel: RootStore.getLovValueForDescription('SetupLevel', self.businessDetail.setupLevel ?? ''),
          premiseType: RootStore.getLovValueForDescription('PremiseType', self.businessDetail?.premiseType ?? ''),
          businessPan: self.businessDetail.businessPAN ?? '',
          ...(isDataChanged(existingBusinessDetail?.webAddress, self.businessDetail?.webAddress) && {
            webAddress: self.businessDetail?.webAddress ?? '',
          }),
          yearsInBusiness: RootStore.getLovValueForDescription(
            'YearsInBusiness',
            self.businessDetail.yearsOfBusiness ?? '',
          ),
          storeType: RootStore.getLovValueForDescription('StoreType', self.businessDetail?.storeType ?? ''),
          businessLine: self.businessDetail?.businessLine ?? '',
          mccCode: self.businessDetail?.mccCode ?? '',
          businessCategory: self.businessDetail.businessCategory ?? '',
          ...(self.businessDetail.mccCode === '5912' && {
            pharmacistName: self.businessDetail?.pharmacistName,
          }),
          ...(isDataChanged(
            existingBusinessDetail?.pharmacyCouncilNumber,
            self.businessDetail.pharmacyCouncilNumber,
          ) && {
            ...(self.businessDetail?.mccCode === '5912' && {
              pharmacyCouncilNumber: self.businessDetail.pharmacyCouncilNumber,
            }),
          }),
          ...(isDataChanged(
            existingBusinessDetail?.dailyTransactionValue,
            self.businessDetail?.dailyTransactionValue,
          ) && {
            dailyTransactionValue: RootStore.getLovValueForDescription(
              'DailyTransactionValue',
              self.businessDetail?.dailyTransactionValue ?? '',
            ),
          }),
          ...(isDataChanged(
            existingBusinessDetail?.dailyTransactionVolume,
            self.businessDetail?.dailyTransactionVolume,
          ) && {
            dailyTransactionVolume: RootStore.getLovValueForDescription(
              'DailyTransactionVolume',
              self.businessDetail?.dailyTransactionVolume ?? '',
            ),
          }),
        },
        //businessProfile Ends
        ...(isDataChanged(existingBusinessDetail?.legalEntityName, self.businessDetail?.legalEntityName) && {
          legalName: self.businessDetail?.legalEntityName ?? '',
        }),
        ...(isDataChanged(existingBusinessDetail?.businessBrandName, self.businessDetail?.businessBrandName) && {
          ...((type === 'Group ID' || type === 'SubGroup ID') && {
            brandName: self.businessDetail?.businessBrandName ?? '',
          }),
          ...(type !== 'Group ID' &&
            type !== 'SubGroup ID' && {
              businessName: self.businessDetail?.businessBrandName ?? '',
            }),
        }),
        ...(isDataChanged(existingBusinessDetail?.merchantOtpDate, self.businessDetail?.merchantOtpDate) &&
          self.businessDetail?.merchantOtpDate !== '' && {
            merchantOtpDate: self.businessDetail?.merchantOtpDate ?? '',
          }),
        ...(isDataChanged(existingBusinessDetail?.deviceOtpDate, self.businessDetail?.deviceOtpDate) &&
          self.businessDetail?.deviceOtpDate !== '' && {
            deviceOtpDate: self.businessDetail?.deviceOtpDate ?? '',
          }),
        gstDetails: {
          gstin: self.businessDetail?.gstNumber ?? '',
          ...(isDataChanged(existingBusinessDetail?.gstDealerCategory, merchantCategory) && {
            merchantCategory: merchantCategory,
          }),
          ...(isDataChanged(existingBusinessDetail?.gstCategory, dealerCategory) && {
            dealerCategory: dealerCategory,
          }),
          ...(isDataChanged(existingBusinessDetail?.jioGstAcceptanceTs, self.businessDetail?.jioGstAcceptanceTs) && {
            jioGST: self.businessDetail?.jioGstAcceptanceTs ?? '',
          }),
          ...(isDataChanged(existingBusinessDetail?.typeOfBusiness, typeOfBusiness) && {
            typeOfBusiness: typeOfBusiness,
          }),
          id: getGstId(entityId, self.searchEntity),
        },
        ...((self as any).getProgramDetailsList()?.length > 0 && {
          programCategoryDetails: (self as any).getProgramDetailsList(),
        }),
        addressDetails: {
          id: getAddressDetailsId(entityId, self.searchEntity),
          addressLine1: self.businessDetail?.primaryAddress1 ?? '',
          addressLine2: self.businessDetail?.primaryAddress2 ?? '',
          ...(isDataChanged(existingBusinessDetail?.primaryAddress2, self.businessDetail?.primaryAddress2) && {
            addressLine3: self.businessDetail?.primaryAddress2 ?? '',
          }),
          pincode: self.businessDetail?.pincode ?? '',
          city: self.businessDetail?.city ?? '',
          state: RootStore.getLovValueForDescription('State', self.businessDetail?.stateUt ?? ''),
          latitude: self.businessDetail?.businessLatitude ?? '',
          longitude: self.businessDetail?.businessLongitude ?? '',
          ...(self.businessDetail?.primaryAddress1?.length > 0 && { addressType: 'COMMUNICATION_ADDR' }),
          ...(self.businessDetail?.primaryAddress1?.length > 0 && { countryCode: '356' }),
        },
        ...(type === 'Group ID' && {
          groupAddress: [
            {
              ...(self.group?.groupAddress?.[0]?.groupAddressReferenceId?.length > 0 && {
                groupAddressReferenceId: self.group?.groupAddress?.[0]?.groupAddressReferenceId,
              }),
              addressLine1: self.businessDetail?.primaryAddress1 ?? '',
              addressLine2: self.businessDetail?.primaryAddress2 ?? '',
              ...(isDataChanged(existingBusinessDetail?.primaryAddress2, self.businessDetail?.primaryAddress2) && {
                addressLine3: self.businessDetail?.primaryAddress2 ?? '',
              }),
              pincode: self.businessDetail?.pincode ?? '',
              city: self.businessDetail?.city ?? '',
              state: self.businessDetail?.stateUt ?? '',
              ...(self.group?.groupAddress?.[0]?.latitude?.length > 0 && {
                latitude: self.group?.groupAddress?.[0]?.latitude ?? '',
              }),
              ...(self.group?.groupAddress?.[0]?.longitude?.length > 0 && {
                longitude: self.group?.groupAddress?.[0]?.longitude ?? '',
              }),
              ...(self.group?.groupAddress?.[0]?.addressType?.length > 0 && {
                addressType: self.group?.groupAddress?.[0]?.addressType,
              }),
              ...(self.group?.groupAddress?.[0]?.countryCode?.length > 0 && {
                countryCode: self.group?.groupAddress?.[0]?.countryCode,
              }),
            },
          ],
        }),
        ...(type !== 'Group ID' &&
          type !== 'SubGroup ID' && {
            feePackageDetails: {
              id: getFeePackageDetailsIdGstId(entityId, self.searchEntity),
              feePackageName:
                !isEmpty(self?.businessDetail?.mdrPackageDetails) && self?.businessDetail?.mdrPackageDetails !== 'NA'
                  ? self.businessDetail?.mdrPackageDetails
                  : '',
              feePkgId:
                !isEmpty(self.businessDetail?.mdrPackageId) && self.businessDetail?.mdrPackageId !== 'NA'
                  ? self.businessDetail?.mdrPackageId
                  : '',
              ...(isDataChanged(
                existingBusinessDetail?.inheritParentFeePackage,
                self.businessDetail?.inheritParentFeePackage,
              ) && {
                inheritParentFeePackage: self.businessDetail?.inheritParentFeePackage === 'No' ? 'false' : 'true',
              }),
            },
          }),
      }
      if (Object.entries(updatedBizzDetails?.businessProfile)?.length > 0) {
        updatedBizzDetails.businessProfile = Object.fromEntries(
          Object.entries(updatedBizzDetails.businessProfile).filter(([_, v]) => v && v.toString().length > 0),
        )
      }
      if (Object.entries(updatedBizzDetails?.gstDetails)?.length > 0) {
        updatedBizzDetails.gstDetails = Object.fromEntries(
          Object.entries(updatedBizzDetails.gstDetails).filter(([_, v]) => v && v.toString().length > 0),
        )
      }
      if (Object.entries(updatedBizzDetails?.addressDetails)?.length > 0) {
        const addresDetailsObj = Object.fromEntries(
          Object.entries(updatedBizzDetails.addressDetails).filter(([_, v]) => v && v.toString().length >= 0),
        )
        if (
          (updatedBizzDetails?.addressDetails?.latitude === '' ||
            updatedBizzDetails?.addressDetails?.latitude === 'NA') &&
          addresDetailsObj &&
          addresDetailsObj?.latitude
        ) {
          addresDetailsObj.latitude = ''
        }
        if (
          (updatedBizzDetails?.addressDetails?.longitude === '' ||
            updatedBizzDetails?.addressDetails?.longitude === 'NA') &&
          addresDetailsObj &&
          addresDetailsObj?.longitude
        ) {
          addresDetailsObj.longitude = ''
        }
        updatedBizzDetails.addressDetails = [addresDetailsObj]
      }
      if (type !== 'Group ID' && type !== 'SubGroup ID') {
        updatedBizzDetails.feePackageDetails = Object.fromEntries(
          Object.entries(updatedBizzDetails.feePackageDetails).filter(([_, v]) => v && v.toString().length > 0),
        )
      }
      if (Object.entries(updatedBizzDetails?.businessProfile)?.length > 0) {
        if (
          JSON.stringify(
            Object.fromEntries(
              Object.entries(updatedBizzDetails?.businessProfile).filter(([_, v]) => v && v.toString().length > 0),
            ),
          ) === '{}'
        ) {
          delete updatedBizzDetails?.businessProfile
        }
      }
      if (Object.entries(updatedBizzDetails?.gstDetails)?.length > 0) {
        if (
          JSON.stringify(
            Object.fromEntries(
              Object.entries(updatedBizzDetails?.gstDetails).filter(([_, v]) => v && v.toString().length > 0),
            ),
          ) === '{}'
        ) {
          delete updatedBizzDetails?.gstDetails
        }
      }
      if (Object.entries(updatedBizzDetails?.addressDetails?.[0])?.length > 0) {
        if (
          JSON.stringify(
            Object.fromEntries(
              Object.entries(updatedBizzDetails.addressDetails?.[0]).filter(([_, v]) => v && v.toString().length > 0),
            ),
          ) === '{}'
        ) {
          delete updatedBizzDetails?.addressDetails
        }
      }
      if (type !== 'Group ID' && type !== 'SubGroup ID') {
        if (
          JSON.stringify(
            Object.fromEntries(
              Object.entries(updatedBizzDetails.feePackageDetails).filter(([_, v]) => v && v.toString().length > 0),
            ),
          ) === '{}'
        ) {
          delete updatedBizzDetails?.feePackageDetails
        }
      }
      if (type === 'Group ID' || type === 'SubGroup ID') {
        if (
          updatedBizzDetails.addressDetails.addressLine1 === undefined &&
          updatedBizzDetails.addressDetails.addressLine2 === undefined &&
          updatedBizzDetails.addressDetails.city === undefined &&
          updatedBizzDetails.addressDetails.pincode === undefined &&
          updatedBizzDetails.addressDetails.state === undefined &&
          updatedBizzDetails.addressDetails.latitude === undefined &&
          updatedBizzDetails.addressDetails.longitude === undefined
        ) {
          delete updatedBizzDetails?.addressDetails
        }
        delete updatedBizzDetails?.gstDetails
        delete updatedBizzDetails?.businessProfile
      }
      console.log('===> updatedBizzDetails: ', updatedBizzDetails)
      return updatedBizzDetails
    },
    getEmsCardsList() {
      return self.cardList
      // let cardsCreatable: any[] = []
      // if (self.cardSelectedList.length > 0) {
      //   self.cardList.map((card) => {
      //     self.cardSelectedList.map((cardSelected) => {
      //       if (card.type !== cardSelected.type && card.scheme !== cardSelected.scheme) {
      //         cardsCreatable.push(card)
      //       }
      //     })
      //   })
      // } else {
      //   cardsCreatable = self.cardList
      // }
      // return cardsCreatable
    },
    getEmsUpdatableCardsList() {
      let cardsUpdatable: any[] = []
      self.cardSelectedList.map((cardSelected) => {
        self.cardList.map((card) => {
          if (card.type === cardSelected.type && card.scheme === cardSelected.scheme) {
            cardsUpdatable.push(card)
          }
        })
      })
      return cardsUpdatable
    },
    getIndividualConfigValueFromKey(key: string) {
      console.log('===> getIndividualConfigValueFromKey: ', key)
      if (self.configList && self.configList?.length > 0) {
        for (let i = 0; i < self.configList?.length; i++) {
          if (self.configList[i].key === key) {
            console.log('===> getIndividualConfigValueFromKey: ', key, self.configList[i].value)
            return self.configList[i].value ?? ''
          }
        }
      }
      return ''
    },
  }))

const onboardingData = Onboarding.create({
  id: '',
  parentMid: '',
  mid: '',
  merchantName: '',
  vpas: [],
  paymentConfig: PaymentConfigData,
  cardConfig: CardConfigInitArr,
  upiConfig: {},
  bankRPartnerConfig: {},
  businessDetail: {},
  group: {},
  entity: {},
  emis: [],
})
export {
  Address,
  BusinessDetail,
  BusinessProfile,
  Checker,
  ContactProfile,
  ContactProfileData,
  EntityContactAddress,
  Onboarding,
  RiskConfigurations,
  onboardingData
}

const extraFieldsDesc = {
  Y: 'yes',
  N: 'No',
}

const getDescriptionLov = (terminalConfigs, key) => {
  return extraFieldsDesc[terminalConfigs.filter((config: any) => config.key === key)?.[0]?.value] || 'NO'
}
